import * as _ from 'lodash';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
import FindClientDialog from  'src/components/client-project/dialogs/FindClientDialog';
import { ITableConfig } from 'src/components/common/table';
import useFetch from 'use-http';
import PBNavBar from '../PBNavBar';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import Button from 'src/components/controls/forms/redesign/FormButton';
import ClientProjectSearch from 'src/components/project-billing/components/ClientProjectSearch';
import TsdiClient from 'src/models/AP/Client';
import { BiAddToQueue, BiLeftArrowAlt, BiRightArrowAlt, BiArrowToLeft, BiArrowToRight } from 'react-icons/bi';
import { FaImage } from 'react-icons/fa';
import { FaTrash } from 'react-icons/fa';
import { FaDownload } from 'react-icons/fa';
import { FaRegSave } from 'react-icons/fa';
import { BsSearch } from 'react-icons/bs';
import { FaBroom } from 'react-icons/fa';
import DialogList from 'src/dialogs';
import actions from 'src/actions';
import { useDispatch } from 'react-redux';
import OfficeExpense from 'src/models/AP/OfficeExpense';
import OfficeExpenseUnitEntry from 'src/models/AP/OfficeExpenseUnit';
import PayPeriod from 'src/models/AP/PayPeriod';
import LoadingSpinner from 'src/components/common/LoadingSpinner';
import ProspectDetails from 'src/models/projectSettings/TsdiProspect';
import TsdiSubcode from 'src/models/AP/Subcode';
import TsdiAltSubcode from 'src/models/AP/AltSubcode';
import WarningDialog from 'src/components/client-project/dialogs/WarningDialog';
import ReceiptViewerDialog from 'src/components/client-project/dialogs/ReceiptViewerDialog';
import TransferExpenseDialog from 'src/components/accounts-payable/dialogs/TransferExpenseDialog';
import OfficeExpenseReportOptionsDialog from 'src/components/accounts-payable/dialogs/OfficeExpenseReportOptionsDialog';
import OfficeExpenseUnitManagementDialog from 'src/components/accounts-payable/dialogs/OfficeExpenseUnitManagementDialog';
import Receipt from '../models/Receipt';
import '../css/ProjectBilling.css';
import { MdAssessment } from 'react-icons/md';

const OfficeExpensePage = () => {
    const dispatch = useDispatch();
    const appContext = useContext<IAppContextState>(AppContext);
    // const expenseTotalRef = useRef(0);
    const { errors} = useForm();
    // tslint:disable-next-line: max-line-length
    const { watch: watchTierOneValues, setValue: setTierOneValue, register: registerTierOneExpenses, reset: resetTierOneExpenses, formState: formStateTierOne, getValues: getTierOneExpenses /*, setValue: setTierOneExpensesValue*/} = useForm();
    const watchedTierOneExpenseValues = watchTierOneValues('officeExpenses');
    const { isDirty: isDirtyTierOne } = formStateTierOne;
    // tslint:disable-next-line: max-line-length
    const { watch: watchTierTwoValues,  setValue: setTierTwoValue, register: registerTierTwoExpenses, reset: resetTierTwoExpenses, formState: formStateTierTwo, getValues: getTierTwoExpenses /*, getValues: getTierTwoExpenses*/} = useForm();
    const watchedTierTwoExpenseValues = watchTierTwoValues('officeExpenses');
    const { isDirty: isDirtyTierTwo } = formStateTierTwo;
    const { register: registerClientValues, reset: resetClientValues, setValue: setClientValue, getValues: getClientValues } = useForm();
    const { get, post, put, del, response } = useFetch();
    const [clients, setClients] = useState<Array<TsdiClient>>(undefined);
    const [clientSearchOptions, setClientSearchOptions] = useState<ODataOptions>(undefined);
    const [payPeriodSearchOptions, setPayPeriodSearchOptions] = useState<ODataOptions>(undefined);
    const [clientSearchTerm, setClientSearchTerm] = useState<string>('');
    const [payPeriodSearchTerm, setPayPeriodSearchTerm] = useState<string>('');
    const [fetchNextClientsPage, setFetchNextClientsPage] = useState<boolean>(true);
    const [fetchNextPayPeriodsPage, setFetchNextPayPeriodsPage] = useState<boolean>(true);
    const [selectedClient, setSelectedClient] = useState<TsdiClient | Partial<TsdiClient>>(undefined);
    const [currentClient, setCurrentClient] = useState<TsdiClient | Partial<TsdiClient>>(undefined);
    const [selectedProject, setSelectedProject] = useState<ProspectDetails | Partial<ProspectDetails>>(undefined);
    const [selectedSubcode, setSelectedSubCode] = useState<TsdiSubcode>(undefined);
    const [selectedAltSubcode, setSelectedAltSubCode] = useState<TsdiAltSubcode>(undefined);
    const [queryMode, setQueryMode] = useState<boolean>(false);
    const [scopedCounter, setScopedCounter] = useState<number>(0);
    const [scopedTotal, setScopedTotal] = useState<number>(0);
    const [editMode, setEditMode] = useState<boolean>(false);
    const [addingProject, setAddingProject] = useState<boolean>(false);
    const [loadingExpenseData, setLoadingExpenseData] = useState<boolean>(false);
    const [newEntryMode, setNewEntryMode] = useState<boolean>(false);    
    const [officeExpenses, setOfficeExpenses] = useState<OfficeExpense[]>(undefined);
    const [officeExpenseIds, setOfficeExpenseIds] = useState<Array<number>>(new Array<number>());
    const [tierOneOfficeExpenses, setTierOneOfficeExpenses] = useState<OfficeExpense[]>(undefined);
    const [tierTwoOfficeExpenses, setTierTwoOfficeExpenses] = useState<OfficeExpense[]>(undefined);
    const [payPeriods, setPayPeriods] = useState<Array<PayPeriod>>(undefined);
    const [receiptThumbnails, setReceiptThumbnails] = useState<Array<Receipt>>(undefined);
    const [selectedPayPeriod, setSelectedPayPeriod] = useState<string>(undefined);
    const [expenseIndex, setExpenseIndex] = useState<number>(undefined);
    const [transferEexpense, setTransferExpense] = useState<{ expenseCategery: string, expenseValue: string}>(undefined);
    const [unitManagementExpense, setUnitManagementExpense] = useState<{ expenseId: string, expenseCategery: string, expenseValue: string}>(undefined);
    const [unitManagementExpenses, setUnitManagementExpenses] = useState<Array<OfficeExpenseUnitEntry>>(undefined);
    const [currentExpenseId, setCurrentExpenseId] = useState<number>(undefined);

    const [tsdiAccounts, setTsdiAccounts] = useState<Array<{ code: number, description: string}>>(undefined);
    const [expenseCodesAndTypes, setExpenseCodesAndTypes] = useState<{ code: number, description: string, type: string}[]>([]);
    // const [imageSrc, setImageSrc] = useState<string | null>(null);
    const queryModeRef = useRef(queryMode);
    const previousClientNumber = useRef<number | null>(null);
    const tierOneTotalRef = useRef(0);
    const tierTwoTotalRef = useRef(0);

    const tierOneExpenseProperties = new Set([
        'phone',
        'postage',
        'shipping',
        'copies',
        'abstractFees',
        'oneThousandTwoAs',
        'fax',
        'officeCopies'
    ]);

    const tierTwoExpenseProperties = new Set([
        'recordingFees',
        'bankCharges',
        'draft',
        'maps',
        'notary',
        'formsAndSupplies',
        'other'
    ]);

    const tierOneTotals = useMemo(() => {
        const totals: Record<string, number> = {};

        if (!watchedTierOneExpenseValues) {
            return totals;
        }

        Array.from(tierOneExpenseProperties).forEach(property => {
            totals[property] = watchedTierOneExpenseValues.reduce(
                (sum: number, row: Partial<OfficeExpense>) =>
                    sum + (Number(row[property as keyof OfficeExpense]) || 0),
                0
            );
        });

        return totals;
    }, [watchedTierOneExpenseValues]);

    const tierTwoTotals = useMemo(() => {
        const totals: Record<string, number> = {};

        if (!watchedTierTwoExpenseValues) {
            return totals;
        }

        Array.from(tierTwoExpenseProperties).forEach(property => {
            totals[property] = watchedTierTwoExpenseValues.reduce(
                (sum: number, row: Partial<OfficeExpense>) =>
                    sum + (Number(row[property as keyof OfficeExpense]) || 0),
                0
            );
        });

        return totals;
    }, [watchedTierTwoExpenseValues]);

    useEffect(() => {
        if (tierOneTotals) {
            tierOneTotalRef.current = Object.values(tierOneTotals).reduce(
                (sum, value) => sum + value,
                0
            );
        }
    }, [tierOneTotals]);

    useEffect(() => {
        if (tierTwoTotals) {
            tierTwoTotalRef.current = Object.values(tierTwoTotals).reduce(
                (sum, value) => sum + value,
                0
            );
        }
    }, [tierTwoTotals]);

    const officeOptionValues = [
        {value: 'ALL', label: 'ALL'},
        {value: 'CO', label: 'CO'},
        {value: 'IH', label: 'IH'},
        {value: 'MD', label: 'MD'},
        {value: 'OK', label: 'OK'},
        {value: 'PA', label: 'PA'},
        {value: 'RN', label: 'RN'},
        {value: 'TX', label: 'TX'}
    ];

/*    const expenseCodesAndTypes = [
        { CODE: 'Z', DSCR: 'discount', TYPE: 'D' },
        { CODE: 'P', DSCR: 'phone', TYPE: 'A' },
        { CODE: 'S', DSCR: 'postage', TYPE: 'A' },
        { CODE: 'F', DSCR: 'shipping', TYPE: 'A' },
        { CODE: 'C', DSCR: 'copies', TYPE: 'A' },
        { CODE: 'A', DSCR: 'abstractFees', TYPE: 'A' },
        { CODE: '1', DSCR: 'oneThousandTwoAs', TYPE: 'A' },
        { CODE: 'X', DSCR: 'fax', TYPE: 'A' },
        { CODE: 'I', DSCR: 'officeCopies', TYPE: 'A' },
        { CODE: 'R', DSCR: 'recordingFees', TYPE: 'B' },
        { CODE: 'B', DSCR: 'bankCharges', TYPE: 'B' },
        { CODE: 'D', DSCR: 'draft', TYPE: 'B' },
        { CODE: 'M', DSCR: 'maps', TYPE: 'B' },
        { CODE: 'N', DSCR: 'notary', TYPE: 'B' },
        { CODE: 'U', DSCR: 'formsAndSupplies', TYPE: 'B' },
        { CODE: 'O', DSCR: 'other', TYPE: 'C' }
    ];

     const expenseCategories = [
        'phone',
        'postage',
        'shipping',
        'copies',
        'abstractFees',
        'oneThousandTwoAs',
        'fax',
        'officeCopies',
        'recordingFees',
        'bankCharges',
        'draft',
        'maps',
        'notary',
        'formsAndSupplies',
        'other',
        'otherDescription'
    ]; */
    const expenseCategoryLabels: Record<string, string> = {
        'Discount': 'discount',
        'Phone': 'phone',
        'Postage': 'postage',
        'Shipping': 'shipping',
        'Copies': 'copies',
        'Abstract Fees': 'abstractFees',
        '1002A\'S': 'oneThousandTwoAs',
        'Fax': 'fax',
        'Office Copies': 'officeCopies',
        'Recording': 'recordingFees',
        'Bank Charges': 'bankCharges',
        'Draft Ext.': 'draft',
        'Maps': 'maps',
        'Notary': 'notary',
        'Forms & Supplies': 'formsAndSupplies',
        'Other': 'other'
    };

    const expenseCategoryMap: Record<string, string> = {
        Discount: 'Discount',
        Phone: 'Phone',
        Postage: 'Postage',
        Shipping: 'Shipping Expenses',
        Copies: 'Copies',
        abstractFees: 'Abstract Fees',
        '1002A\'S': '1002A\'S',
        Fax: 'Fax',
        'Office Copies': 'Office Copies',
        'Recording': 'Recording Fees',
        'Bank Charges': 'Bank Charges',
        Draft: 'Draft Ext.',
        Maps: 'Maps',
        Notary: 'Notary',
        'Supplies': 'Forms & Supplies',
        'Other': 'Other'
    };

    // Initial render
    useEffect(() => {
        onCreate();

        // TODO: *cry* 😭✅
        return () => {
            onDestroy();
        };
    }, []);

    useEffect(() => {
        if (!!clientSearchOptions) {
            getClients();
        }
    }, [clientSearchOptions]);

    useEffect(() => {
        if (transferEexpense) {
            showDialog(DialogList.TRANSFER_OFFICE_EXPENSE);
        }
    }, [transferEexpense]);

/*    useEffect(() => {
        if (tierOneTotal > 0 || tierTwoTotal > 0) {
            setLabelValue(tierOneTotal + tierTwoTotal, 'expensesTotal');
        }
    }, [tierOneTotal, tierTwoTotal]); */

    useEffect(() => {
        if (Array.isArray(receiptThumbnails) && receiptThumbnails.length > 0) {
            setClientValue('billingReceipts', receiptThumbnails.length);
        }
    }, [receiptThumbnails]);

    useEffect(() => {
        if (!!tierOneOfficeExpenses && !!tierTwoOfficeExpenses) {
            console.log(tierOneOfficeExpenses.length + ' , ' + tierTwoOfficeExpenses.length);
        }
    }, [tierOneOfficeExpenses, tierTwoOfficeExpenses]);

    useEffect(() => {
        if (!!addingProject) {
            showDialog(DialogList.FIND_PROJECT);
        }
    }, [addingProject]);

    useEffect(() => {
        if (Array.isArray(officeExpenseIds) && officeExpenseIds.length > 0) {
            setCurrentExpenseId(officeExpenseIds[0]);
        }
    }, [officeExpenseIds]);

    useEffect(() => {
        if (Array.isArray(officeExpenses) && officeExpenses.length > 0 &&
                Array.isArray(tsdiAccounts) && tsdiAccounts.length > 0) {
            // setImageSrc(officeExpenses[0].imageBase64);
            setLoadingExpenseData(false);
            if (officeExpenses[0].id !== -1) {
                const newExpenseIndex = 0;
                setExpenseIndex(newExpenseIndex);
                populateOfficeExpenseIds();
                populateExpenseDisplayObjects();
                setClientValue('offices', officeExpenses[0]?.billingOffice);
                setClientValue('accountName', tsdiAccounts.find(a => a.code === Number(officeExpenses[0].accountNumber))?.description);
                setClientValue('accountNumber', officeExpenses[0]?.accountNumber);
            } else {
                populateBlankExpenseDisplayObjects();
                resetAllTotals();
            }

        }
    }, [officeExpenses, tsdiAccounts]);

    useEffect(() => {
        const clientNumber = currentClient?.clientNumber ?? null;

        if (
            clientNumber !== null &&
            clientNumber !== previousClientNumber.current
        ) {
            setScopedCounter(1);
            previousClientNumber.current = clientNumber;
        }
    }, [currentClient?.clientNumber]);

    useEffect(() => {
        const currentT1Expenses = getTierOneExpenses()?.officeExpenses;
        const currentT2Expenses = getTierTwoExpenses()?.officeExpenses;
        let expenseId = null;
        if (Array.isArray(currentT1Expenses)) {
            const lastObject = Object.values(currentT1Expenses).pop();
            expenseId = Number(lastObject?.id);
        }
        if (!expenseId) {
            if (Array.isArray(currentT2Expenses)) {
                const lastObject2 = Object.values(currentT2Expenses).pop();
                expenseId = Number(lastObject2?.id);
            }
        }

        const currentOfficeExpense = officeExpenses ? officeExpenses.find(oe => oe.id === currentExpenseId) : null;
        if (currentOfficeExpense) {
            setCurrentClient({ clientNumber: currentOfficeExpense.clientNumber, clientName: currentOfficeExpense.clientName});
            setClientValue('clientNumber', currentOfficeExpense?.clientNumber);
            setClientValue('clientName', currentOfficeExpense?.clientName);
            setClientValue('projectNumber', currentOfficeExpense?.projectNumber);
            setClientValue('projectName', currentOfficeExpense?.projectName);
            setClientValue('subcodeNumber', currentOfficeExpense?.sectionNumber);
            setClientValue('subcodeName', currentOfficeExpense?.sectionName);
            setClientValue('altSubcodeNumber', currentOfficeExpense?.unitNumber);
            setClientValue('altSubcodeName', currentOfficeExpense?.unitName);
            // setSelectedProject({ number: currentOfficeExpense.projectNumber, name: currentOfficeExpense.projectName });
        }
        if (expenseIndex !== undefined && !!tierOneOfficeExpenses) {
            // populateTierOneExpenseFormValues(tierOneOfficeExpenses);
            if (!!officeExpenses && officeExpenses?.length >= expenseIndex) {
                if (!isNaN(officeExpenses[expenseIndex]?.sectionNumber)) {
                    const subcode = new TsdiSubcode();
                    subcode.number = officeExpenses[expenseIndex]?.sectionNumber;
                    if (!!officeExpenses[expenseIndex]?.sectionName) {
                        subcode.name = officeExpenses[expenseIndex]?.sectionName;
                    }
                    setSelectedSubCode(subcode);
                    if (!isNaN(officeExpenses[expenseIndex]?.unitNumber)) {
                        const altSubcode = new TsdiAltSubcode();
                        altSubcode.number = officeExpenses[expenseIndex]?.unitNumber;
                        if (!!officeExpenses[expenseIndex]?.unitName) {
                            subcode.name = officeExpenses[expenseIndex]?.sectionName;
                        }
                        setSelectedAltSubCode(altSubcode);
                    }
                }
            }
            // resetClientProjectFormValues(false);
            getOfficeExpenseReceiptsThumbnails();
            setScopedCounter(scopedCounter === 0 ? 1 : scopedCounter);
            getCurrentExpenseIdTotal();
            if (currentOfficeExpense) {
                setClientValue('offices', currentOfficeExpense?.billingOffice);
                setClientValue('accountNumber', currentOfficeExpense?.accountNumber);
            }
        }
    }, [expenseIndex]);

    useEffect(() => {
        if (!!selectedPayPeriod && selectedPayPeriod.length > 0) {
            setClientValue(`payPeriod`, selectedPayPeriod);
            if (!!selectedClient && !isNaN(selectedClient?.clientNumber)) {
                getOfficeExpenses();
            }
        }
    }, [selectedPayPeriod]);

    useEffect(() => {
        if ((!!clientSearchTerm || clientSearchTerm === '') && !!clientSearchOptions) {
            resetClientSearchOptions();
        }
    }, [clientSearchTerm]);

    useEffect(() => {
        if (!!payPeriodSearchOptions) {
            getPayPeriods();
        }
    }, [payPeriodSearchOptions]);

    useEffect(() => {
        if ((!!payPeriodSearchTerm || payPeriodSearchTerm === '') && !!payPeriodSearchOptions) {
            resetPayPeriodSearchOptions();
        }
    }, [payPeriodSearchTerm]);

    useEffect(() => {
        getClients();
    }, [clientSearchOptions]);

    useEffect(() => {
        if (!!clients && clients.length > 0) {
            prepFormData();
        }
    }, [clients]);

    useEffect(() => {
        if (!!selectedClient) {
            if (!!clients && clients?.length > 0) {
                setClientValue('clientNumber', selectedClient?.clientNumber);
                setCurrentClient(selectedClient);
            }
            if (!!selectedPayPeriod && selectedPayPeriod.length > 0 && !!selectedClient && !isNaN(selectedClient?.clientNumber)) {
                getOfficeExpenses();
            }
        }
    }, [selectedClient]);

    // Keep the ref in sync with the state
    useEffect(() => {
        queryModeRef.current = queryMode;
    }, [queryMode]);

    const onCreate = () => {
        setClientValue('subcodeName', 'some subcode');
        // Put all initialization code here.
        getOfficeExpenseCodes();
        createQueryKeyListener();
        initializeClientSearchSettings();
        initializePayPeriodSearchSettings();
        getBillingAccounts();
    };

    const populateOfficeExpenseIds = () => {
        const allOfficeExpenseIds = officeExpenses.map(e => { return e.id; });
        const uniqueNumbers = allOfficeExpenseIds.filter((value, index, self) => self.indexOf(value) === index);
        setOfficeExpenseIds([...uniqueNumbers]);
    };

    const getOfficeExpenseCodes = async () => {
        let result = await get(`/v1.0/AccountsPayable/billing/expensetypes`);

        if (response.ok) {
            setExpenseCodesAndTypes(result);
        } else {
            console.log('Unable to get Office Expense Code Data!!!');
        }
    };

/*     const tierOneExpenseCodes: string[] = [
        'P',
        'S',
        'F',
        'C',
        'A',
        '1',
        'X',
        'I',
    ]; */

    const populateExpenseDisplayObjects = () => {
        if (!!officeExpenses) {
            const newTierOneOfficeExpenses = normalizeTierOneOfficeExpenses(officeExpenses);
            const newTierTwoOfficeExpenese = normalizeTierTwoOfficeExpenses(officeExpenses);
/*             console.log(tierOneOfficeExpenses);
            console.log(tierTwoOfficeExpenses);
            const newTierOneExpenses = new Array<OfficeExpense>();
            const newTierTwoExpenses = new Array<OfficeExpense>();
            officeExpenses.forEach((oe, index) => {
                oe.officeExpenses.forEach((oe2, index2) => {
                    if (tierOneExpenseCodes.includes(oe2.code)) {
                        newTierOneExpenses.push(oe2);
                    } else {
                        newTierTwoExpenses.push(oe2);
                    }
                });
            });
            setTierTwoOfficeExpenses(newTierTwoExpenses); */
            setTierTwoOfficeExpenses(newTierTwoOfficeExpenese);
            setTierOneOfficeExpenses(newTierOneOfficeExpenses);
        }
    };

    const populateBlankExpenseDisplayObjects = () => {
        if (!!officeExpenses) {
            // populateTierOneExpenseFormValues(officeExpenses);
            const newTierOneRow: OfficeExpenseRow[] = [
                { id: -1, accountNumber: 1, phone: '', postage: '', shipping: '', copies: '', abstractFees: '', fax: '', officeCopies: '', oneThousandTwoAs: '', unitIds: {} }
            ];
            const newTierTwoRow: TierTwoOfficeExpenseRow[] = [
                { id: -1, accountNumber: 1, recordingFees: '', bankCharges: '', draft: '', maps: '', notary: '', formsAndSupplies: '', other: '', otherDescription: '', unitIds: {} }
            ];
            setTierTwoOfficeExpenses(newTierTwoRow);
            setTierOneOfficeExpenses(newTierOneRow);
        }
    };

    const insertCharAt = (str: string, charToInsert: string, index: number) => {
        return str.slice(0, index) + charToInsert + str.slice(index);
    };

    const getBillingAccounts = async () => {
        let result = await get(`/v1.0/AccountsPayable/billing/accounts`);

        if (response.ok) {
            setTsdiAccounts(result);
        } else {
            console.log('Unable to get Billing Accounts Data!!!');
        }
    };

    const getPayPeriods = async () => {        
        const queryString = payPeriodSearchOptions.toString();
        let result = await get(`/v1.0/AccountsPayable/payperiods${queryString}`);

        if (response.ok) {
            setPayPeriods(result.items.map((pp: PayPeriod) => {
                const insertIndex = pp.periodNumber.toString().length - 2;
                const ppString = insertCharAt(pp.periodNumber.toString(), '-', insertIndex);
                return { id: pp.id, name: ppString, beginDate: pp.beginDate, endDate: pp.endDate };
            }));
        } else {
            console.log('Unable to get pay period data!!!');
        }
    };

    const getCodeOrType = (dscr: string, returnCode: boolean) => {
        const expenseDescription = expenseCategoryMap[dscr];
        const match = expenseCodesAndTypes.find(entry =>
            entry.description === (expenseDescription ? expenseDescription : '')
        );
      
        if (!match) {
            return null;
        }
      
        return (returnCode ? match.code : match.type).toString();
      };      

    const initializePayPeriodSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 500,
            idField: 'Id',
            pageNumber: 1,
            columns: []
        };
        const newPayPeriodSearchOptions = ODataOptions.from(tableConfig);
        newPayPeriodSearchOptions.addOrderBy('Id', ODataOrderByDirection.Descending);
        const currentDate = new Date();
        const currentDate2 = new Date();
        const beginDate = new Date(currentDate.setMonth(currentDate.getMonth() - 12)).toLocaleDateString().replace('/', '-').replace('/', '-');
        const endDate = new Date(currentDate2.setMonth(currentDate2.getMonth() + 6)).toLocaleDateString().replace('/', '-').replace('/', '-');
        newPayPeriodSearchOptions?.addFilter(new ODataFilter('end_date', ODataFilterOperators.LessThan, endDate));
        newPayPeriodSearchOptions?.addFilter(new ODataFilter('beg_date', ODataFilterOperators.GreaterThan, beginDate));
        
        setPayPeriodSearchOptions(newPayPeriodSearchOptions);
    };
      
    type OfficeExpenseUnit = {
        unitId?: number;
        accountNumber?: number;
        code?: string;
        amount?: number;
        otherDescription?: string;
    };
      
    type OfficeExpenseRow = {
        id: number;
        accountNumber: number;
        phone: string | null;
        postage: string | null;
        shipping: string | null;
        copies: string | null;
        abstractFees: string | null;
        oneThousandTwoAs: string | null;
        fax: string | null;
        officeCopies: string | null;
        unitIds: { [key: string]: number };
    };
      
    type TierTwoOfficeExpenseRow = {
        id: number;
        accountNumber: number;
        recordingFees: string | null;
        bankCharges: string | null;
        draft: string | null;
        maps: string | null;
        notary: string | null;
        formsAndSupplies: string | null;
        other: string | null;
        otherDescription: string | null;
        unitIds: { [key: string]: number };
    };

    const tierTwocodeToPropertyMap: { [key: string]: keyof TierTwoOfficeExpenseRow } = {
        R: 'recordingFees',
        B: 'bankCharges',
        D: 'draft',
        M: 'maps',
        N: 'notary',
        U: 'formsAndSupplies',
        O: 'other'
    };

    const codeToPropertyMap: { [key: string]: keyof OfficeExpenseRow } = {
        I: 'officeCopies',
        P: 'phone',
        S: 'postage',
        F: 'shipping',
        C: 'copies',
        A: 'abstractFees',
        '1': 'oneThousandTwoAs',
        X: 'fax',
    };
      
    const normalizeTierOneOfficeExpenses = (expenses: OfficeExpense[]): OfficeExpenseRow[] => {
        const result: OfficeExpenseRow[] = [];

        for (const expense of expenses) {
            // Step 1: Group units by code
            const codeGroups: Record<string, OfficeExpenseUnit[]> = {};

            for (const unit of expense?.officeExpenses) {
                if (!codeGroups[unit.code] && unit.code in codeToPropertyMap) {
                    codeGroups[unit.code] = [];
                }
                if (unit.code in codeToPropertyMap) {
                    codeGroups[unit.code].push(unit);
                }
            }

            // Step 2: Determine how many rows we need (max count of any code group)
            const maxLength = Math.max(
                ...Object.values(codeGroups).map(group => group.length),
                0
            );

            // Step 3: Build rows
            for (let i = 0; i < maxLength; i++) {
                const row: OfficeExpenseRow = {
                    id: expense.id,
                    accountNumber: expense.accountNumber,
                    phone: null,
                    postage: null,
                    shipping: null,
                    copies: null,
                    abstractFees: null,
                    oneThousandTwoAs: null,
                    fax: null,
                    officeCopies: null,
                    unitIds: {}
                };

                // Fill the row with the i-th item from each code group
                for (const [code, group] of Object.entries(codeGroups)) {
                    const property = codeToPropertyMap[code];
                    if (!property) {
                        continue;
                    }

                    const unit = group?.[i];
                    if (unit) {
                        (row as unknown as Record<string, number | null>)[property] = unit.amount;
                        row.unitIds[property] = unit.unitId;
                    }
                }

                result.push(row);
            }
        }

        return result;
    };

    const showReceiptViewerDialog = () => {
        showDialog(DialogList.RECEIPT_VIEWER);
    };

    const loadPayPeriodExpenses = async () => {
        const payPeriod = selectedPayPeriod;
        let result = await post(`/v1.0/AccountsPayable/billing/office/expenses/load/payperiod/${payPeriod}`);

        if (response.ok && result.sourceType === 0) {
            getOfficeExpenses();
        } else {
            alert('Office Expense Check failed. Source: ${result.sourceType}. Type: ${result.SourceId}. Amount: ${result.sourceAmount}');
        }
    };

    const normalizeTierTwoOfficeExpenses = (expenses: OfficeExpense[]): TierTwoOfficeExpenseRow[] => {
        const result: TierTwoOfficeExpenseRow[] = [];
        
        for (const expense of expenses) {
            // Step 1: Group units by code
            const codeGroups: Record<string, OfficeExpenseUnit[]> = {};
        
            for (const unit of expense.officeExpenses) {
                if (!codeGroups[unit.code] && unit.code in tierTwocodeToPropertyMap) {
                    codeGroups[unit.code] = [];
                }
                if (unit.code in tierTwocodeToPropertyMap) {
                    codeGroups[unit.code].push(unit);
                }
            }
        
            // Step 2: Determine how many rows we need (max count of any code group)
            const maxLength = Math.max(...Object.values(codeGroups).map(group => group.length), 0);
        
            // Step 3: Build rows
            for (let i = 0; i < maxLength; i++) {
            const row: TierTwoOfficeExpenseRow = {
                id: expense.id,
                accountNumber: expense.accountNumber,
                recordingFees: null,
                bankCharges: null,
                draft: null,
                maps: null,
                notary: null,
                formsAndSupplies: null,
                other: null,
                otherDescription: null,
                unitIds: {}
            };
        
            // Fill the row with the i-th item from each code group
            for (const [code, group] of Object.entries(codeGroups)) {
                const property = tierTwocodeToPropertyMap[code];
                if (!property) {
                    continue;
                }
                
                const unit = group[i];
                if (unit) {
                    (row[property as keyof TierTwoOfficeExpenseRow] as string | null | number) = unit.amount;
                    if (!!row.other && !!unit.otherDescription) {
                        row.otherDescription = unit.otherDescription;
                    }
                    if (unit) {
                        (row as unknown as Record<string, number | null>)[property] = unit.amount;
                        row.unitIds[property] = unit.unitId;
                    }
                }                
            }
        
            result.push(row);
            }
        }
        
        return result;
    };
                      
    const onDestroy = () => {
        // Put all destruction code here.
        removeQueryKeyListener();
    };

    const hideDialog = () => {
        setAddingProject(false);
        setEditMode(false);
        dispatch(actions.layout.hideDialog());
    };

    const onCancel = () => {
        hideDialog();
    };

    const getClients = async () => {
        const queryString = clientSearchOptions?.toString();
        let result = await get(`/v1.0/AccountsPayable/clients${queryString}`);

        if (response.ok) {
            setClients([]);
            setClients(result.items);
            // Todo: get this from the DB and set it when the client is set from FindClientsDialog
        } else {
            setClients([]);
            console.log('Unable to get client data!');
        }
    };

    const getBillingCodeIsValid = async () => {
        const searchFormData = getClientValues();
        const options = new ODataOptions();
        const clientNumber = !isNaN(Number(searchFormData.clientNumber)) ? Number(searchFormData.clientNumber) : null;
        const ProjectNumber = !isNaN(Number(searchFormData.projectNumber)) ? Number(searchFormData.projectNumber) : null;
        const SectionNumber = !isNaN(Number(searchFormData.subcodeNumber)) ? Number(searchFormData.subcodeNumber) : null;
        const UnitNumber = !isNaN(Number(searchFormData.altSubcodeNumber)) ? Number(searchFormData.altSubcodeNumber) : null;
        if (clientNumber !== null && ProjectNumber !== null) {
            options.addFilter(new ODataFilter('ClientNumber', ODataFilterOperators.Equals, clientNumber));
            options.addFilter(new ODataFilter('ProjectNumber', ODataFilterOperators.Equals, ProjectNumber));
            options.addFilter(new ODataFilter('SectionNumber', ODataFilterOperators.Equals, SectionNumber));
            options.addFilter(new ODataFilter('UnitNumber', ODataFilterOperators.Equals, UnitNumber));
            const queryString = options.toString();
            let result = await get(`/v1.0/AccountsPayable/billing/code/isvalid${queryString}`);

            if (response.ok && result === 1) {
                getOfficeExpenses();
            } else {
                console.log('Unable to validate billing code!');
            }
        }
    };

    const initializeClientSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 100,
            idField: 'CL_NO',
            pageNumber: 1,
            columns: []
        };
        setClientSearchOptions(ODataOptions.from(tableConfig).addOrderBy('NAME1', ODataOrderByDirection.Ascending));
    };

    const prepFormData = () => {
        if (!!clients && clients?.length > 0) {
            console.log(clients[0]);
        }
    };

    const displayTitle = () => {
        const title = 'Office Expenses';

        return title;
    };

    const displayHeading2 = () => {
        const title = 'Expenses';

        return title;
    };

    const resetClientSearchOptions = () => {
        setFetchNextClientsPage(true);
        console.log(fetchNextClientsPage);
        let newClientSearchOptions = _.cloneDeep(clientSearchOptions);
        newClientSearchOptions.clearFilters();
        newClientSearchOptions.addPaging(1, 50);
        if (typeof clientSearchTerm === 'string') {
            const fieldValues = clientSearchTerm.split(',');
            if (fieldValues[0] !== undefined && !isNaN(Number(fieldValues[0]))) {
                newClientSearchOptions.addFilter(new ODataFilter('CL_NO', ODataFilterOperators.Equals, !!clientSearchTerm ? fieldValues[0] : ''));
            }
            if (fieldValues[1] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('NAME1', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[1] : ''));
            }
            if (fieldValues[2] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('NAME2', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[2] : ''));
            }
            if (fieldValues[3] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('CITY', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[3] : ''));
            }
            if (fieldValues[4] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('STATE', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[4] : ''));
            }
            if (fieldValues[5] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('ZIP', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[5] : ''));
            }
            if (fieldValues[6] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('PHONE', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[6] : ''));
            }
        }
        setClientSearchOptions(newClientSearchOptions);
    };

    const resetPayPeriodSearchOptions = () => {
        setFetchNextPayPeriodsPage(true);
        console.log(fetchNextPayPeriodsPage);
        let newPayPeriodSearchOptions = _.cloneDeep(payPeriodSearchOptions);
        newPayPeriodSearchOptions.clearFilters();
        newPayPeriodSearchOptions.addPaging(1, 200);
        const payPeriod = Number(payPeriodSearchTerm.replace('-', ''));
        if (!isNaN(payPeriod)) {
            newPayPeriodSearchOptions.addFilter(new ODataFilter('PERIOD_NO', ODataFilterOperators.Contains, payPeriod));
        }
        setPayPeriodSearchOptions(newPayPeriodSearchOptions);
    };

    const resetAllTotals = () => {
        let element = document.getElementById('OtherExpenseTotal') as HTMLLabelElement;
        if (!!element) {
            element.innerText = '0.00';
        }
        element = document.getElementById('RecordingExpenseTotal') as HTMLLabelElement;
        if (!!element) {
            element.innerText = '0.00';
        }
        element = document.getElementById('BankChargesTotal') as HTMLLabelElement;
        if (!!element) {
            element.innerText = '0.00';
        }
        element = document.getElementById('DraftExpenseTotal') as HTMLLabelElement;
        if (!!element) {
            element.innerText = '0.00';
        }
        element = document.getElementById('MapsExpenseTotal') as HTMLLabelElement;
        if (!!element) {
            element.innerText = '0.00';
        }
        element = document.getElementById('PhoneExpenseTotal') as HTMLLabelElement;
        if (!!element) {
            element.innerText = '0.00';
        }
        element = document.getElementById('PostageExpenseTotal') as HTMLLabelElement;
        if (!!element) {
            element.innerText = '0.00';
        }
        element = document.getElementById('ShippingExpenseTotal') as HTMLLabelElement;
        if (!!element) {
            element.innerText = '0.00';
        }
        element = document.getElementById('CopiesExpenseTotal') as HTMLLabelElement;
        if (!!element) {
            element.innerText = '0.00';
        }
        element = document.getElementById('AbstractsExpenseTotal') as HTMLLabelElement;
        if (!!element) {
            element.innerText = '0.00';
        }
        element = document.getElementById('1002AsExpenseTotal') as HTMLLabelElement;
        if (!!element) {
            element.innerText = '0.00';
        }
        element = document.getElementById('FaxExpenseTotal') as HTMLLabelElement;
        if (!!element) {
            element.innerText = '0.00';
        }
        element = document.getElementById('OfficeCopiesExpenseTotal') as HTMLLabelElement;
        if (!!element) {
            element.innerText = '0.00';
        }
        element = document.getElementById('expensesTotal') as HTMLLabelElement;
        if (!!element) {
            element.innerText = '0.00';
        }
        element = document.getElementById('SuppliesExpenseTotal') as HTMLLabelElement;
        if (!!element) {
            element.innerText = '0.00';
        }
        element = document.getElementById('NotoryExpenseTotal') as HTMLLabelElement;
        if (!!element) {
            element.innerText = '0.00';
        }
    };

    const displayOfficeExpenseButtons = () => {
        return (
            <>
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Find Pay Period"
                    reactIcon={BsSearch}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => findClient()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Reports"
                    reactIcon={MdAssessment}
                    iconHoverColor="blue"
                    iconStyle={{fill: 'rgb(99, 147, 193)', width: '2.5rem', height: '2.5rem', verticalAlign: 'center', marginBottom: '.2rem'}}
                    onClick={() => reportOptions()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Add New Expense"
                    reactIcon={BiAddToQueue}
                    iconHoverColor="blue"
                    iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                    onClick={prepareAddExpenseForm}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Clear Form"
                    reactIcon={FaBroom}
                    iconHoverColor="blue"
                    iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                    onClick={resetForm}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Save Changes"
                    reactIcon={FaRegSave}
                    type={'submit'}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to First Expense"
                    reactIcon={BiArrowToLeft}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={moveToFirstExpense}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Previous Expense"
                    reactIcon={BiLeftArrowAlt}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={moveToPreviousExpense}
                />
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
                    <label>{expenseIndex !== undefined ? (expenseIndex + 1) : '0'}</label>
                    <label style={{marginLeft: '1rem'}}>of</label>
                    <label style={{marginLeft: '1rem'}}>{officeExpenseIds?.length ? officeExpenseIds?.length : '0'}</label>
                    <label style={{marginLeft: '1rem'}}>( {currentClient?.clientNumber}: {scopedCounter} of {scopedTotal})</label>
                </div>
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Next Record"
                    reactIcon={BiRightArrowAlt}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={moveToNextExpense}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Last Record"
                    reactIcon={BiArrowToRight}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={moveToLastExpense}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Delete Expense"
                    reactIcon={FaTrash}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => deleteOfficeExpenses()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Load Pay Period Expenses"
                    reactIcon={FaDownload}
                    iconHoverColor="blue"
                    iconStyle={{fill: 'rgb(99, 147, 193)', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => loadPayPeriodExpenses()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="View Receipts"
                    reactIcon={FaImage}
                    iconHoverColor="blue"
                    iconStyle={{fill: 'rgb(241, 193, 90)', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => showReceiptViewerDialog()}
                />
            </>
        );
    };

    const displayOfficeExpenses = () => {
        return (
            <>
            <div className="form-row" style={{ alignItems: 'flex-end', marginBottom: '0', whiteSpace: 'nowrap' }}>
                <RHFInputBox
                    readOnly={!queryMode}
                    label={'Pay Period'}
                    labelOnLeft={true}
                    name={'payPeriod'}
                    style={{ width: '100%' }}
                    bodyStyle={{width: '30%' }}
                    register={registerClientValues}
                />
                <RHFInputBox
                    readOnly={true}
                    type={'number'}
                    label={'Account #'}
                    labelOnLeft={true}
                    name={'accountNumber'}
                    register={registerClientValues}
                    style={{ width: '100%' }}
                    bodyStyle={{width: '20%' }}
                />
                <RHFInputBox
                    readOnly={true}
                    type={'text'}
                    name={'accountName'}
                    register={registerClientValues}
                    style={{marginBottom: '1rem', width: '100%' }}
                    bodyStyle={{ width: '65%' }}
                />
                <RHFSelect
                    label="Office"
                    labelOnLeft={true}
                    labelStyle={{whiteSpace: 'nowrap'}}
                    name={`offices`}
                    options={officeOptionValues}
                    register={registerClientValues}
                    errors={errors}
                    style={{ width: '100%' }}
                    bodyStyle={{width: '20%' }}
                />
                <RHFInputBox
                    readOnly={true}
                    label={'Receipts'}
                    labelOnLeft={true}
                    name={'billingReceipts'}
                    register={registerClientValues}
                    style={{
                        backgroundColor:
                                Array.isArray(receiptThumbnails) && receiptThumbnails?.length > 0
                                ? 'rgb(252, 205, 105)'
                                : '',
                        width: '100%',
                        textAlign: 'center'
                    }}
                    bodyStyle={{width: '20%' }}
                    onDoubleClick={() => showReceiptViewerDialog()}
                />
                <div style={{marginBottom: '1rem', display: 'flex', alignItems: 'flex-end'}}>
                    <label>Expenses Total:</label>
                    <label style={{fontSize: '1.7rem', padding: '.5rem', marginLeft: '5px', minHeight: '20px', minWidth: '42px', border: 'solid black 1.5px', backgroundColor: '#6DEEF7'}} id={'expensesTotal'}>{formatCurrencyString(tierOneTotalRef.current + tierTwoTotalRef.current)}</label>
                </div>
                {/*<RHFInputBox
                    type={'number'}
                    label={'Total Expenses:'}
                    labelOnLeft={true}
                    id={'expensesTotal'}
                    name={'expensesTotal'}
                    register={registerClientValues}
                    readOnly={true}
                    style={{ width: '100%' }}
                    bodyStyle={{width: '50%' }}
                />*/}
            </div>
            <div className="form-row" style={{ marginBottom: '1rem' }}>
                <form id={`OfficeExpenseFormTierOne`} onSubmit={onSubmit}>
                    {displayTierOneExpenses(registerTierOneExpenses)}
                </form>
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <form id={`OfficeExpenseFormTierTwo`} onSubmit={onSubmit}>
                    {displayTierTwoExpenses()}
                </form>
            </div>
            </>
        );
    };

/*     const displayTierOneExpenses = (scopedRegister: typeof registerTierOneExpenses) => {
        let phoneTotal = 0;
        let postageTotal = 0;
        let shippingTotal = 0;
        let copiesTotal = 0;
        let abstractsTotal = 0;
        let one002asTotal = 0;
        let faxTotal = 0;
        let officeCopiesTotal = 0;
        let recordingTotal = 0;
        let bankChargesTotal = 0;
        let draftsTotal = 0;
        let mapsTotal = 0;
        let notaryTotal = 0;
        let suppliesTotal = 0;
        let otherTotal = 0;
        return (
            <table style={{borderBottom: '1rem'}}>
                <thead>
                    <th style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>Phone</th>
                    <th style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>Postage</th>
                    <th style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>Shipping</th>
                    <th style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>Copies</th>
                    <th style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>Abstracts</th>
                    <th style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>1002As</th>
                    <th style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>Fax</th>
                    <th style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>Office Copies</th>
                </thead>
                <tbody className={'project-billing'}>
                {!loadingExpenseData && expenseIndex !== undefined && !!tierOneExpenseCodes && officeExpenses?.length > 0 && officeExpenses?.map(
                    (oe: OfficeExpense, index: number) => {
                        const id = !!officeExpenses[expenseIndex]?.id ? officeExpenses[expenseIndex]?.id : 0;
                        if ( !!id && id === oe.id && hasExpenses(oe, 1)) {
                            phoneTotal += !isNaN(Number(oe.phone)) ? Number(oe.phone) : 0.0;
                            setLabelValue(phoneTotal, 'PhoneExpenseTotal');
                            postageTotal += !isNaN(Number(oe.postage)) ? Number(oe.postage) : 0.0;
                            setLabelValue(postageTotal, 'PostageExpenseTotal');
                            shippingTotal += !isNaN(Number(oe.shipping)) ? Number(oe.shipping) : 0.0;
                            setLabelValue(shippingTotal, 'ShippingExpenseTotal');
                            copiesTotal += !isNaN(Number(oe.copies)) ? Number(oe.copies) : 0.0;
                            setLabelValue(copiesTotal, 'CopiesExpenseTotal');
                            abstractsTotal += !isNaN(Number(oe.abstractFees)) ? Number(oe.abstractFees) : 0.0;
                            setLabelValue(abstractsTotal, 'AbstractsExpenseTotal');
                            one002asTotal += !isNaN(Number(oe.oneThousandTwoAs)) ? Number(oe.oneThousandTwoAs) : 0.0;
                            setLabelValue(one002asTotal, '1002AsExpenseTotal');
                            faxTotal += !isNaN(Number(oe.fax)) ?  Number(oe.fax) : 0.0;
                            setLabelValue(faxTotal, 'FaxExpenseTotal');
                            officeCopiesTotal += !isNaN(Number(oe.officeCopies)) ?  Number(oe.officeCopies) : 0.0;
                            setLabelValue(officeCopiesTotal, 'OfficeCopiesExpenseTotal');
                            recordingTotal += !isNaN(Number(oe.recordingFees)) ? Number(oe.recordingFees) : 0.0;
                            setLabelValue(recordingTotal, 'RecordingExpenseTotal');
                            bankChargesTotal += !isNaN(Number(oe.bankCharges)) ? Number(oe.bankCharges) : 0.0;
                            setLabelValue(bankChargesTotal, 'BankChargesTotal');
                            draftsTotal += !isNaN(Number(oe.draft)) ? Number(oe.draft) : 0.0;
                            setLabelValue(draftsTotal, 'DraftExpenseTotal');
                            mapsTotal += !isNaN(Number(oe.maps)) ? Number(oe.maps) : 0.0;
                            setLabelValue(mapsTotal, 'MapsExpenseTotal');
                            notaryTotal += !isNaN(Number(oe.notary)) ? Number(oe.notary) : 0.0;
                            setLabelValue(notaryTotal, 'NotaryExpenseTotal');
                            suppliesTotal += !isNaN(Number(oe.formsAndSupplies)) ? Number(oe.formsAndSupplies) : 0.0;
                            setLabelValue(suppliesTotal, 'SuppliesExpenseTotal');
                            otherTotal += !isNaN(Number(oe.other)) ? Number(oe.other) : 0.0;
                            setLabelValue(otherTotal, 'OtherExpenseTotal');
                            setLabelValue(phoneTotal + postageTotal + shippingTotal + copiesTotal + abstractsTotal + one002asTotal +
                                faxTotal + officeCopiesTotal + recordingTotal + bankChargesTotal + draftsTotal + mapsTotal +
                                notaryTotal + suppliesTotal + otherTotal, 'expensesTotal');
                            return (
                                <tr
                                    key={index}
                                    tabIndex={0}
                                    id={'officeExpenseRow' + index}
                                    className="table-item-hover"
                                    style={{ textAlign: 'center' }}
                                    onDoubleClick={() => setEditMode(true)}
                                >
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].phone`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="number"
                                            defaultVal={oe?.phone}
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{ width: '100%', textAlign: 'center' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].postage`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="number"
                                            defaultVal={oe?.postage}
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{ width: '100%', textAlign: 'left' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].shipping`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="number"
                                            defaultVal={oe?.shipping}
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{backgroundColor: `${oe.entrySource === 'AP' ? '#66FF00' : ''}`, width: '100%', textAlign: 'center' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].copies`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="number"
                                            defaultVal={oe?.copies}
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{ width: '100%', textAlign: 'center' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].abstractFees`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="number"
                                            defaultVal={oe?.abstractFees}
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{ width: '100%', textAlign: 'center' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].oneThousandTwoAs`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="number"
                                            defaultVal={oe?.oneThousandTwoAs}
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{ width: '100%', textAlign: 'center' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].fax`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="number"
                                            defaultVal={oe?.fax}
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{ width: '100%', textAlign: 'center' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].officeCopies`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="number"
                                            defaultVal={oe?.officeCopies}
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{ width: '100%', textAlign: 'center' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                </tr>
                            );
                        } else {
                            return null;
                        }
                    })}
                    <tr style={{height: '20px'}}>
                        <td style={{ border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}><label id={'PhoneExpenseTotal'}/></td>
                        <td style={{ border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}><label id={'PostageExpenseTotal'}/></td>
                        <td style={{ textAlign: 'center' , border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}><label id={'ShippingExpenseTotal'}/></td>
                        <td style={{ border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}><label id={'CopiesExpenseTotal'}/></td>
                        <td style={{ border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}><label id={'AbstractsExpenseTotal'}/></td>
                        <td style={{ border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}><label id={'1002AsExpenseTotal'}/></td>
                        <td style={{ border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}><label id={'FaxExpenseTotal'}/></td>
                        <td style={{ border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}><label id={'OfficeCopiesExpenseTotal'}/></td>
                    </tr>
                </tbody>
            </table>
        );
    };
 */

    const findEntrySource = (officeExpense: OfficeExpense, property: string) => {
        const unitId = officeExpense?.unitIds?.[property];

        if (!unitId) {
            return null;
        }

        const oeArray = officeExpenses.find(oe => oe?.id === currentExpenseId);

        const entrySourceParent = oeArray?.officeExpenses.find(
            oep => oep.unitId === unitId
        );

        return entrySourceParent?.entrySource ?? null;
    };

    const prepareManageExpenseUnitDialog = (tier: number, expenseType: string) => {
        // Get the current OFFICE_EXPENSE_UNIT entries for expenseType
        const officeExpenseUnits = new Array<OfficeExpenseUnitEntry>();
        const expenseId = officeExpenseIds[expenseIndex] ? officeExpenseIds[expenseIndex] : 0;
        if (tier === 1 && Array.isArray(tierOneOfficeExpenses)) {
            for (let expenseUnitIndex = 0; expenseUnitIndex < tierOneOfficeExpenses.length; expenseUnitIndex++) {
                const propertyValue = tierOneOfficeExpenses[expenseUnitIndex][expenseCategoryLabels[expenseType] as keyof OfficeExpense];
                if (propertyValue && !isNaN(Number(propertyValue))) {
                    const targetUnitId = tierOneOfficeExpenses[expenseUnitIndex].unitIds[expenseCategoryLabels[expenseType]];
                    const officeExpenseUnitEntry = {
                        id: targetUnitId,
                        description: expenseType, amount: propertyValue.toString()
                    };
                    const entrySource = officeExpenses.find(oe => oe.unitId === targetUnitId)?.entrySource;
                    if ( expenseId && expenseId === tierOneOfficeExpenses?.[expenseUnitIndex]?.id && (entrySource === 'FORM' || !entrySource)) {
                        officeExpenseUnits.push(officeExpenseUnitEntry);
                    }
                }
            }
        } else if (Array.isArray(tierTwoOfficeExpenses)) {
            for (let expenseUnitIndex = 0; expenseUnitIndex < tierTwoOfficeExpenses.length; expenseUnitIndex++) {
                const propertyValue = tierTwoOfficeExpenses[expenseUnitIndex][expenseCategoryLabels[expenseType] as keyof OfficeExpense];
                if (propertyValue && !isNaN(Number(propertyValue))) {
                    const targetUnitId = tierTwoOfficeExpenses[expenseUnitIndex].unitIds[expenseCategoryLabels[expenseType]];
                    const officeExpenseUnitEntry = {
                        id: targetUnitId,
                        description: expenseType, amount: propertyValue.toString()
                    };
                    const entrySource = officeExpenses.find(oe => oe.unitId === targetUnitId)?.entrySource;
                    if ( expenseId && expenseId === tierTwoOfficeExpenses?.[expenseUnitIndex]?.id && (entrySource === 'FORM' || !entrySource)) {
                        officeExpenseUnits.push(officeExpenseUnitEntry);
                    }
                }
            }
        }

        setUnitManagementExpense({ expenseId: '1', expenseCategery: expenseType, expenseValue: '1.00'});
        setUnitManagementExpenses(Array.isArray(officeExpenseUnits) && officeExpenseUnits.length > 0 ? officeExpenseUnits : [
            { id: null, description: expenseType, amount: null}
        ]);

        showDialog(DialogList.MANAGE_OFFICE_EXPENSE_UNIT);

    };

    const displayTierOneExpenses = (scopedRegister: typeof registerTierOneExpenses) => {
        tierOneTotalRef.current = 0;
        let phoneTotal = 0;
        let postageTotal = 0;
        let shippingTotal = 0;
        let copiesTotal = 0;
        let abstractsTotal = 0;
        let one002asTotal = 0;
        let faxTotal = 0;
        let officeCopiesTotal = 0;

        return (
            <table className={'project-billing'} style={{borderBottom: '1rem'}}>
                <caption className="project-billing-legend">
                    <span className="m-legend"/> Manual
                    <span className="v-legend"/> Voucher
                    <span className="vv-legend"/> Void Voucher
                    <span className="cc-legend"/> Credit Card
                </caption>
                <thead className={'project-billing'}>
                    <th onDoubleClick={() => prepareManageExpenseUnitDialog(1, 'Phone')} style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>Phone</th>
                    <th onDoubleClick={() => prepareManageExpenseUnitDialog(1, 'Postage')} style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>Postage</th>
                    <th onDoubleClick={() => prepareManageExpenseUnitDialog(1, 'Shipping')} style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>Shipping</th>
                    <th onDoubleClick={() => prepareManageExpenseUnitDialog(1, 'Copies')} style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>Copies</th>
                    <th onDoubleClick={() => prepareManageExpenseUnitDialog(1, 'Abstract Fees')} style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>Abstracts</th>
                    <th onDoubleClick={() => prepareManageExpenseUnitDialog(1, '1002A\'S')} style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>1002As</th>
                    <th onDoubleClick={() => prepareManageExpenseUnitDialog(1, 'Fax')} style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>Fax</th>
                    <th onDoubleClick={() => prepareManageExpenseUnitDialog(1, 'Office Copies')} style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>Office Copies</th>
                </thead>
                <tbody className={'project-billing'}>
                {!loadingExpenseData && expenseIndex !== undefined && !!tierOneOfficeExpenses && tierOneOfficeExpenses?.length > 0 && tierOneOfficeExpenses?.map(
                    (oe: OfficeExpense, index: number) => {
                        const id = !!officeExpenseIds[expenseIndex] ? officeExpenseIds[expenseIndex] : 0;
                        if ( !!id && id === oe.id && hasExpenses(oe, 1)) {
                            const faxEntrySource = findEntrySource(oe, 'fax');
                            const officeCopiesEntrySource = findEntrySource(oe, 'officeCopies');
                            const expenseTotal = phoneTotal + postageTotal + shippingTotal + copiesTotal + abstractsTotal + one002asTotal +
                                faxTotal + officeCopiesTotal;

                            tierOneTotalRef.current = expenseTotal;

                            return (
                                <tr
                                    key={index}
                                    tabIndex={0}
                                    id={'officeExpenseRow' + index}
                                    className="project-billing table-item-hover"
                                    style={{ textAlign: 'center' }}
                                    onDoubleClick={() => setEditMode(true)}
                                >
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].phone`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="text"
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{ width: '100%', textAlign: 'center' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].id`}
                                            bodyStyle={{ display: 'none' } }
                                            register={scopedRegister}
                                        />
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].unitId`}
                                            bodyStyle={{ display: 'none' } }
                                            register={scopedRegister}
                                        />
                                    </td>
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].postage`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="text"
                                            defaultVal={!!oe?.postage ? formatCurrencyString(Number(oe?.postage)) : ''}
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{backgroundColor: `${findEntrySource(oe, 'postage') === 'AP' ? '#66FF00' : findEntrySource(oe, 'postage') === 'CC' ?
                                                '#faf75ef8' : ''}`, width: '100%', textAlign: 'right' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].shipping`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="text"
                                            defaultVal={!!oe?.shipping ? formatCurrencyString(Number(oe?.shipping)) : ''}
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{backgroundColor: `${findEntrySource(oe, 'shipping') === 'AP' ? '#66FF00' : findEntrySource(oe, 'shipping') === 'CC' ?
                                                '#faf75ef8' : ''}`, width: '100%', textAlign: 'right' } }
                                            bodyStyle={{ width: '100%' }}
                                            onDoubleClick={() => setTransferExpense({ expenseCategery: 'Shipping', expenseValue: oe?.shipping })}
                                        />
                                    </td>
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].copies`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="text"
                                            defaultVal={oe?.copies ? formatCurrencyString(Number(oe.copies)) : ''}
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{backgroundColor: `${findEntrySource(oe, 'copies') === 'AP' ? '#66FF00' : findEntrySource(oe, 'copies') === 'CC' ?
                                                '#faf75ef8' : ''}`, width: '100%', textAlign: 'right' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].abstractFees`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="text"
                                            defaultVal={oe?.abstractFees}
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{color: findEntrySource(oe, 'abstractFees') === 'VOIDAP' ? 'white' : '', backgroundColor: `${findEntrySource(oe, 'abstractFees') === 'AP' ? '#66FF00' : findEntrySource(oe, 'abstractFees') === 'CC' ?
                                                '#faf75ef8' : findEntrySource(oe, 'abstractFees') === 'VOIDAP' ? '#ff6d6d' : ''}`, width: '100%', textAlign: 'right' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].oneThousandTwoAs`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="text"
                                            defaultVal={oe?.oneThousandTwoAs ? formatCurrencyString(Number(oe.oneThousandTwoAs)) : ''}
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{color: findEntrySource(oe, 'oneThousandTwoAs') === 'VOIDAP' ? 'white' : '', backgroundColor: `${findEntrySource(oe, 'oneThousandTwoAs') === 'AP' ? '#66FF00' : findEntrySource(oe, 'oneThousandTwoAs') === 'CC' ?
                                                '#faf75ef8' : findEntrySource(oe, 'oneThousandTwoAs') === 'VOIDAP' ? '#ff6d6d' : ''}`, width: '100%', textAlign: 'right' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].fax`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="text"
                                            defaultVal={oe?.fax ? formatCurrencyString(Number(oe.fax)) : ''}
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{color: faxEntrySource === 'VOIDAP' ? 'white' : '', backgroundColor: `${faxEntrySource === 'AP' ? '#66FF00' : faxEntrySource === 'CC' ?
                                                '#faf75ef8' : faxEntrySource === 'VOIDAP' ? '#ff6d6d' : ''}`, width: '100%', textAlign: 'right' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].officeCopies`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="text"
                                            defaultVal={
                                                oe?.officeCopies != null
                                                    ? formatCurrencyString(Number(oe.officeCopies))
                                                    : ''
                                            }
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{color: officeCopiesEntrySource === 'VOIDAP' ? 'white' : '', backgroundColor: `${officeCopiesEntrySource === 'AP' ? '#66FF00' : officeCopiesEntrySource === 'CC' ?
                                                '#faf75ef8' : officeCopiesEntrySource === 'VOIDAP' ? '#ff6d6d' : ''}`, width: '100%', textAlign: 'right' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                </tr>
                            );
                        } else if (tierOneOfficeExpenses?.[index]?.id === -1) {
                            return (
                                <tr
                                    key={index}
                                    tabIndex={0}
                                    id={'officeExpenseRow' + index}
                                    className="project-billing table-item-hover"
                                    style={{ textAlign: 'center' }}
                                    onDoubleClick={() => setEditMode(true)}
                                >
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].phone`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="text"
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{ width: '100%', textAlign: 'center' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].id`}
                                            bodyStyle={{ display: 'none' } }
                                            register={scopedRegister}
                                        />
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].unitId`}
                                            bodyStyle={{ display: 'none' } }
                                            register={scopedRegister}
                                        />
                                    </td>
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses.${index}.postage`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="text"
                                            // defaultVal={!!oe?.postage ? formatCurrencyString(Number(oe?.postage)) : ''}
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{ width: '100%', textAlign: 'center' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].shipping`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="text"
                                            defaultVal={!!oe?.shipping ? formatCurrencyString(Number(oe?.shipping)) : ''}
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{ width: '100%', textAlign: 'center' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].copies`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="text"
                                            defaultVal={oe?.copies ? formatCurrencyString(Number(oe.copies)) : ''}
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{ width: '100%', textAlign: 'center' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].abstractFees`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="text"
                                            defaultVal={oe?.abstractFees}
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{ width: '100%', textAlign: 'center' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].oneThousandTwoAs`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="text"
                                            defaultVal={oe?.oneThousandTwoAs ? formatCurrencyString(Number(oe.oneThousandTwoAs)) : ''}
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{ width: '100%', textAlign: 'center' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].fax`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="text"
                                            defaultVal={oe?.fax ? formatCurrencyString(Number(oe.fax)) : ''}
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{ width: '100%', textAlign: 'center' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                    </td>
                                    <td style={{ border: 'solid rgb(99, 147, 193) 1px',  width: '6%' }}>
                                        <RHFInputBox
                                            name={`officeExpenses[${index}].officeCopies`}
                                            readOnly={!newEntryMode && !editMode}
                                            type="text"
                                            defaultVal={
                                                oe?.officeCopies != null
                                                    ? formatCurrencyString(Number(oe.officeCopies))
                                                    : ''
                                            }
                                            register={scopedRegister}
                                            errors={errors}
                                            style={{ width: '100%', textAlign: 'center' } }
                                            bodyStyle={{ width: '100%' }}
                                        />
                                        <input
                                            type="hidden"
                                            name={`officeExpenses.${index}.unitId`}
                                            value={oe?.unitId}
                                            ref={scopedRegister}
                                        />
                                    </td>
                                </tr>
                            );
                        } else {
                            return null;
                        }
                    })}
                    <tr className={'project-billing'} style={{height: '20px'}}>
                        <td style={{ fontSize: '1.6rem', paddingRight: '1rem', textAlign: 'right' , border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}>
                            <label id={'PhoneExpenseTotal'}>{!isNaN(Number(tierOneTotals.phone)) ? formatCurrencyString(Number(tierOneTotals.phone)) : ''}</label></td>
                        <td style={{ fontSize: '1.6rem', paddingRight: '1rem', textAlign: 'right' , border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}>
                            <label id={'PostageExpenseTotal'}>{!isNaN(Number(tierOneTotals.postage)) ? formatCurrencyString(Number(tierOneTotals.postage)) : ''}</label></td>
                        <td style={{ fontSize: '1.6rem', paddingRight: '1rem', textAlign: 'right' , border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}>
                            <label id={'ShippingExpenseTotal'}>{!isNaN(Number(tierOneTotals.shipping)) ? formatCurrencyString(Number(tierOneTotals.shipping)) : ''}</label></td>
                        <td style={{ fontSize: '1.6rem', paddingRight: '1rem', textAlign: 'right' , border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}>
                            <label id={'CopiesExpenseTotal'}>{!isNaN(Number(tierOneTotals.copies)) ? formatCurrencyString(Number(tierOneTotals.copies)) : ''}</label></td>
                        <td style={{ fontSize: '1.6rem', paddingRight: '1rem', textAlign: 'right' , border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}>
                            <label id={'AbstractsExpenseTotal'}>{!isNaN(Number(tierOneTotals.abstractFees)) ? formatCurrencyString(Number(tierOneTotals.abstractFees)) : ''}</label></td>
                        <td style={{ fontSize: '1.6rem', paddingRight: '1rem', textAlign: 'right' , border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}>
                            <label id={'1002AsExpenseTotal'}>{!isNaN(Number(tierOneTotals.oneThousandTwoAs)) ? formatCurrencyString(Number(tierOneTotals.oneThousandTwoAs)) : ''}</label></td>
                        <td style={{ fontSize: '1.6rem', paddingRight: '1rem', textAlign: 'right' , border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}>
                            <label id={'FaxExpenseTotal'}>{!isNaN(Number(tierOneTotals.fax)) ? formatCurrencyString(Number(tierOneTotals.fax)) : ''}</label></td>
                        <td style={{ fontSize: '1.6rem', paddingRight: '1rem', textAlign: 'right' , border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}>
                            <label id={'OfficeCopiesExpenseTotal'}>{!isNaN(Number(tierOneTotals.officeCopies)) ? formatCurrencyString(Number(tierOneTotals.officeCopies)) : ''}</label></td>
                    </tr>
                </tbody>
            </table>
        );
    };

/*    const setLabelValue = (value: number, id: string) => {
        const labelRef = document.getElementById(id) as HTMLLabelElement;
        if (!!labelRef) {
            labelRef.innerText = formatCurrencyString(value);
        }
    };*/

    const getOfficeExpensesReportFile = async (outputType: number, timePeriod: number, office: string) => {
        if (!!timePeriod && office) {
            await get(`v1.0/reports/GetReport/${outputType}/officeExpenses/timeperiod/${timePeriod}/office/${office}`);
            if (response.ok) {
                await response.blob().then((blob) => {
                    const blobUrl = window.URL.createObjectURL(blob);
                    const a = document.createElement('a') as HTMLAnchorElement;
                    a.href = blobUrl;
                    a.download = outputType === 1 ? `${timePeriod}-${office}-OfficeExpenses.xlsx` : `${timePeriod}-${office}-OfficeExpenses.pdf`;
                    a.click();
                    window.URL.revokeObjectURL(blobUrl);
                });
            }
        } else {
            alert('No time period and/or employeeId selected!');
        }
    };

    const hasExpenses = (expense: OfficeExpense, tier: number) => {
        if (tier === 1) {
            if (expense.abstractFees === null && expense.copies === null && expense.discount === null && expense.fax === null &&
                  expense.officeCopies === null && expense.oneThousandTwoAs === null && expense.other === null && expense.phone === null &&
                  expense.postage === null && expense.receipts === null && expense.shipping === null) {
                return false;
            } else {
                return true;
            }
        } else {
            if (expense.recordingFees === null && expense.bankCharges === null && expense.draft === null && expense.maps === null && expense.formsAndSupplies === null  &&
                 expense.notary === null && expense.other === null) {
                return false;
            } else {
                return true;
            }
        }
    };

/*    const updateFormsAndSuppliesTotals = (target: EventTarget & HTMLInputElement, index: number) => {
        let newTotal = Number(target.value);
        if (target.name.includes('formsAndSupplies')) {
            const oldValue = officeExpenses[index].formsAndSupplies;
            newTotal = (Number(newTotal) - Number(oldValue));
            const element = document.getElementById('SuppliesExpenseTotal') as HTMLLabelElement;
            const formData = getTierTwoExpenses();
            formData.officeExpenses.forEach((e: {formsAndSupplies: number}) =>
                newTotal += Number(e.formsAndSupplies)
            );
            if (!!element) {
                element.innerText = formatCurrencyString(newTotal);
            }
        }
    };

    const updateOtherTotals = (target: EventTarget & HTMLInputElement, index: number) => {
        let newTotal = Number(target.value);
        if (target.name.includes('other')) {
            const oldValue = officeExpenses[index].other;
            newTotal = (Number(newTotal) - Number(oldValue));
            const element = document.getElementById('OtherExpenseTotal') as HTMLLabelElement;
            const formData = getTierTwoExpenses();
            formData.officeExpenses.forEach((e: {other: number}) =>
                newTotal += Number(e.other)
            );
            if (!!element) {
                element.innerText = formatCurrencyString(newTotal);
            }
        }
    }; */

    const displayTierTwoExpenses = () => {
        tierTwoTotalRef.current = 0;
        return(
            <table className={'project-billing'}>
                <thead className={'project-billing'} style={{border: 'solid black 1.5px'}}>
                    <th onDoubleClick={() => prepareManageExpenseUnitDialog(2, 'Recording')} style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>Recording Fees</th>
                    <th onDoubleClick={() => prepareManageExpenseUnitDialog(2, 'Bank Charges')} style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>Bank Charges</th>
                    <th onDoubleClick={() => prepareManageExpenseUnitDialog(2, 'Draft')} style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>Draft</th>
                    <th onDoubleClick={() => prepareManageExpenseUnitDialog(2, 'Maps')} style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>Maps</th>
                    <th onDoubleClick={() => prepareManageExpenseUnitDialog(2, 'Notary')} style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>Notary</th>
                    <th onDoubleClick={() => prepareManageExpenseUnitDialog(2, 'Supplies')} style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>Forms & Supplies</th>
                    <th onDoubleClick={() => prepareManageExpenseUnitDialog(2, 'Other')} style={{ border: 'solid black 1.5px', backgroundColor: '#89FA68', width: '6%' }}>Other</th>
                    <th style={{ border: 'solid black 1.5px', backgroundColor: 'lightgray', width: '8%' }}>Description</th>
                </thead>
                <tbody className={'project-billing'}>
                {!!tierTwoOfficeExpenses && tierTwoOfficeExpenses?.length > 0 && tierTwoOfficeExpenses?.map(
                    (oe: OfficeExpense, index: number) => {
                    const id = !!officeExpenseIds[expenseIndex] ? officeExpenseIds[expenseIndex] : 0;
                    if ( !!id && id === oe.id && hasExpenses(oe, 2) && id !== 0) {
                        return (
                            <tr
                                key={index}
                                tabIndex={0}
                                id={'officeExpenseRow' + index}
                                className="project-billing table-item-hover"
                                style={{ textAlign: 'center' }}
                                onDoubleClick={() => setEditMode(true)}
                            >
                                <td style={{ border: 'solid rgb(99, 147, 193) 1px', width: '6%', textAlign: 'center'  }}>
                                    <RHFInputBox
                                        name={`officeExpenses[${index}].recordingFees`}
                                        readOnly={!newEntryMode && !editMode}
                                        type="text"
                                        defaultVal={oe?.recordingFees ? formatCurrencyString(Number(oe.recordingFees)) : ''}
                                        register={registerTierTwoExpenses}
                                        errors={errors}
                                        style={{backgroundColor: `${findEntrySource(oe, 'recordingFees') === 'AP' ? '#66FF00' : findEntrySource(oe, 'recordingFees') === 'CC' ?
                                            '#faf75ef8' : ''}`, width: '100%', textAlign: 'right' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ border: 'solid rgb(99, 147, 193) 1px', width: '6%', textAlign: 'center'  }}>
                                    <RHFInputBox
                                        name={`officeExpenses[${index}].bankCharges`}
                                        readOnly={!newEntryMode && !editMode}
                                        type="text"
                                        defaultVal={oe?.bankCharges ? formatCurrencyString(Number(oe.bankCharges)) : ''}
                                        register={registerTierTwoExpenses}
                                        errors={errors}
                                        style={{backgroundColor: `${findEntrySource(oe, 'bankCharges') === 'AP' ? '#66FF00' : findEntrySource(oe, 'bankCharges') === 'CC' ?
                                            '#faf75ef8' : ''}`, width: '100%', textAlign: 'right' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ border: 'solid rgb(99, 147, 193) 1px', width: '6%', textAlign: 'center'  }}>
                                    <RHFInputBox
                                        name={`officeExpenses[${index}].draft`}
                                        readOnly={!newEntryMode && !editMode}
                                        type="text"
                                        defaultVal={oe?.draft ? formatCurrencyString(Number(oe.draft)) : ''}
                                        register={registerTierTwoExpenses}
                                        errors={errors}
                                        style={{backgroundColor: `${findEntrySource(oe, 'draft') === 'AP' ? '#66FF00' : findEntrySource(oe, 'draft') === 'CC' ?
                                            '#faf75ef8' : ''}`, width: '100%', textAlign: 'right' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ border: 'solid rgb(99, 147, 193) 1px', width: '6%', textAlign: 'center'  }}>
                                    <RHFInputBox
                                        name={`officeExpenses[${index}].maps`}
                                        readOnly={!newEntryMode && !editMode}
                                        type="text"
                                        defaultVal={oe?.maps ? formatCurrencyString(Number(oe.maps)) : ''}
                                        register={registerTierTwoExpenses}
                                        errors={errors}
                                        style={{backgroundColor: `${findEntrySource(oe, 'maps') === 'AP' ? '#66FF00' : findEntrySource(oe, 'maps') === 'CC' ?
                                            '#faf75ef8' : ''}`, width: '100%', textAlign: 'right' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ border: 'solid rgb(99, 147, 193) 1px', width: '6%', textAlign: 'center'  }}>
                                    <RHFInputBox
                                        name={`officeExpenses[${index}].notary`}
                                        readOnly={!newEntryMode && !editMode}
                                        type="text"
                                        defaultVal={oe?.notary ? formatCurrencyString(Number(oe.notary)) : ''}
                                        register={registerTierTwoExpenses}
                                        errors={errors}
                                        style={{backgroundColor: `${findEntrySource(oe, 'notary') === 'AP' ? '#66FF00' : findEntrySource(oe, 'notary') === 'CC' ?
                                            '#faf75ef8' : ''}`, width: '100%', textAlign: 'right' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ border: 'solid rgb(99, 147, 193) 1px', width: '6%'}}>
                                    <RHFInputBox
                                        name={`officeExpenses[${index}].formsAndSupplies`}
                                        readOnly={!newEntryMode && !editMode}
                                        type="text"
                                        defaultVal={oe?.formsAndSupplies ? formatCurrencyString(Number(oe.formsAndSupplies)) : ''}
                                        register={registerTierTwoExpenses}
                                        errors={errors}
                                        style={{backgroundColor: `${findEntrySource(oe, 'formsAndSupplies') === 'AP' ? '#66FF00' : findEntrySource(oe, 'formsAndSupplies') === 'CC' ?
                                            '#faf75ef8' : ''}`, width: '100%', textAlign: 'right' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ border: 'solid rgb(99, 147, 193) 1px', width: '6%', textAlign: 'center'  }}>
                                    <RHFInputBox
                                        name={`officeExpenses[${index}].other`}
                                        readOnly={!newEntryMode && !editMode}
                                        type="text"
                                        defaultVal={oe?.other ? formatCurrencyString(Number(oe.other)) : ''}
                                        register={registerTierTwoExpenses}
                                        errors={errors}
                                        style={{backgroundColor: `${findEntrySource(oe, 'other') === 'AP' ? '#66FF00' : findEntrySource(oe, 'other') === 'CC' ?
                                            '#faf75ef8' : ''}`, width: '100%', textAlign: 'right' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ border: 'solid rgb(99, 147, 193) 1px', width: '8%', textAlign: 'center'  }}>
                                    <RHFInputBox
                                        name={`officeExpenses[${index}].otherDescription`}
                                        readOnly={!newEntryMode && !editMode}
                                        type="text"
                                        defaultVal={oe?.otherDescription}
                                        register={registerTierTwoExpenses}
                                        errors={errors}
                                        style={{ width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                            </tr>
                        );
                    } else if (tierTwoOfficeExpenses?.[index]?.id === -1) {
                        return (
                        <tr
                            key={index}
                            tabIndex={0}
                            id={'officeExpenseRow' + index}
                            className="project-billing table-item-hover"
                            style={{ textAlign: 'center' }}
                            onDoubleClick={() => setEditMode(true)}
                        >
                            <td style={{ border: 'solid rgb(99, 147, 193) 1px', width: '6%', textAlign: 'center'  }}>
                                <RHFInputBox
                                    name={`officeExpenses[${index}].recordingFees`}
                                    readOnly={!newEntryMode && !editMode}
                                    type="text"
                                    defaultVal={oe?.recordingFees ? formatCurrencyString(Number(oe.recordingFees)) : ''}
                                    register={registerTierTwoExpenses}
                                    errors={errors}
                                    style={{ width: '100%', textAlign: 'right' } }
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{ border: 'solid rgb(99, 147, 193) 1px', width: '6%', textAlign: 'center'  }}>
                                <RHFInputBox
                                    name={`officeExpenses[${index}].bankCharges`}
                                    readOnly={!newEntryMode && !editMode}
                                    type="text"
                                    defaultVal={oe?.bankCharges ? formatCurrencyString(Number(oe.bankCharges)) : ''}
                                    register={registerTierTwoExpenses}
                                    errors={errors}
                                    style={{ width: '100%', textAlign: 'right' } }
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{ border: 'solid rgb(99, 147, 193) 1px', width: '6%', textAlign: 'center'  }}>
                                <RHFInputBox
                                    name={`officeExpenses[${index}].draft`}
                                    readOnly={!newEntryMode && !editMode}
                                    type="text"
                                    defaultVal={oe?.draft ? formatCurrencyString(Number(oe.draft)) : ''}
                                    register={registerTierTwoExpenses}
                                    errors={errors}
                                    style={{ width: '100%', textAlign: 'right' } }
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{ border: 'solid rgb(99, 147, 193) 1px', width: '6%', textAlign: 'center'  }}>
                                <RHFInputBox
                                    name={`officeExpenses[${index}].maps`}
                                    readOnly={!newEntryMode && !editMode}
                                    type="text"
                                    defaultVal={oe?.maps ? formatCurrencyString(Number(oe.maps)) : ''}
                                    register={registerTierTwoExpenses}
                                    errors={errors}
                                    style={{ width: '100%', textAlign: 'right' } }
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{ border: 'solid rgb(99, 147, 193) 1px', width: '6%', textAlign: 'center'  }}>
                                <RHFInputBox
                                    name={`officeExpenses[${index}].notary`}
                                    readOnly={!newEntryMode && !editMode}
                                    type="text"
                                    defaultVal={oe?.notary ? formatCurrencyString(Number(oe.notary)) : ''}
                                    register={registerTierTwoExpenses}
                                    errors={errors}
                                    style={{ width: '100%', textAlign: 'right' } }
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{ border: 'solid rgb(99, 147, 193) 1px', width: '6%'}}>
                                <RHFInputBox
                                    name={`officeExpenses[${index}].formsAndSupplies`}
                                    readOnly={!newEntryMode && !editMode}
                                    type="text"
                                    defaultVal={oe?.formsAndSupplies ? formatCurrencyString(Number(oe.formsAndSupplies)) : ''}
                                    register={registerTierTwoExpenses}
                                    errors={errors}
                                    style={{ width: '100%', textAlign: 'right' } }
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{ border: 'solid rgb(99, 147, 193) 1px', width: '6%', textAlign: 'center'  }}>
                                <RHFInputBox
                                    name={`officeExpenses[${index}].other`}
                                    readOnly={!newEntryMode && !editMode}
                                    type="text"
                                    defaultVal={oe?.other ? formatCurrencyString(Number(oe.other)) : ''}
                                    register={registerTierTwoExpenses}
                                    errors={errors}
                                    style={{ width: '100%', textAlign: 'right' } }
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{ border: 'solid rgb(99, 147, 193) 1px', width: '8%', textAlign: 'center'  }}>
                                <RHFInputBox
                                    name={`officeExpenses[${index}].otherDescription`}
                                    readOnly={!newEntryMode && !editMode}
                                    type="text"
                                    defaultVal={oe?.otherDescription}
                                    register={registerTierTwoExpenses}
                                    errors={errors}
                                    style={{ width: '100%' } }
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                        </tr>
                    ); } else {
                        return null;
                    }
                })}
                <tr className={'project-billing'} style={{height: '20px'}}>
                    <td style={{ fontSize: '1.6rem', paddingRight: '1rem', textAlign: 'right', border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}>
                        <label id={'RecordingExpenseTotal'}>{!isNaN(Number(tierTwoTotals.recordingFees)) ? formatCurrencyString(Number(tierTwoTotals.recordingFees)) : ''}</label></td>
                    <td style={{ fontSize: '1.6rem', paddingRight: '1rem', textAlign: 'right', border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}>
                        <label id={'BankChargesTotal'}>{!isNaN(Number(tierTwoTotals.bankCharges)) ? formatCurrencyString(Number(tierTwoTotals.bankCharges)) : ''}</label></td>
                    <td style={{ fontSize: '1.6rem', paddingRight: '1rem', textAlign: 'right', border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}>
                        <label id={'DraftExpenseTotal'}>{!isNaN(Number(tierTwoTotals.draft)) ? formatCurrencyString(Number(tierTwoTotals.draft)) : ''}</label></td>
                    <td style={{ fontSize: '1.6rem', paddingRight: '1rem', textAlign: 'right', border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}>
                        <label id={'MapsExpenseTotal'}>{!isNaN(Number(tierTwoTotals.maps)) ? formatCurrencyString(Number(tierTwoTotals.maps)) : ''}</label></td>
                    <td style={{ fontSize: '1.6rem', paddingRight: '1rem', textAlign: 'right', border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}>
                        <label id={'NotaryExpenseTotal'}>{!isNaN(Number(tierTwoTotals.notary)) ? formatCurrencyString(Number(tierTwoTotals.notary)) : ''}</label></td>
                    <td style={{ fontSize: '1.6rem', paddingRight: '1rem', textAlign: 'right', border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}>
                        <label id={'SuppliesExpenseTotal'}>{!isNaN(Number(tierTwoTotals.formsAndSupplies)) ? formatCurrencyString(Number(tierTwoTotals.formsAndSupplies)) : ''}</label></td>
                    <td style={{ fontSize: '1.6rem', paddingRight: '1rem', textAlign: 'right', border: 'solid black 1.5px', backgroundColor: '#6DEEF7', width: '6%' }}>
                        <label id={'OtherExpenseTotal'}>{!isNaN(Number(tierTwoTotals.other)) ? formatCurrencyString(Number(tierTwoTotals.other)) : ''}</label></td>
                    <td style={{ border: 'solid black 1.5px', backgroundColor: 'lightgray', width: '8%' }}/>
                </tr>
                </tbody>
            </table>
        );
    };

    const formatCurrencyString = (value: number) =>
        value.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

    const initializeOfficeExpenseSearchSettings = (clientNumber: number, payPeriod: number) => {
        const tableConfig: ITableConfig = {
            rowCount: 500,
            idField: 'OF_ID',
            pageNumber: 1,
            columns: []
        };
        const billingExpenseSearchOptions = ODataOptions.from(tableConfig);
        billingExpenseSearchOptions.addOrderBy('oe.OF_ID', ODataOrderByDirection.Ascending);
        if (!!payPeriod && payPeriod > 0) {
            billingExpenseSearchOptions?.addFilter(new ODataFilter('oe.[PERIOD_NO]', ODataFilterOperators.Equals, payPeriod));
        }
        if (!!clientNumber && clientNumber > 0) {
            billingExpenseSearchOptions?.addFilter(new ODataFilter('oe.[CL_NO]', ODataFilterOperators.Equals, clientNumber));
        }
        
        return billingExpenseSearchOptions.toString();
    };

/*    const formatExpensePayload = (payload: Array<OfficeExpense>): Array<OfficeExpense> => {
        return payload.map(expense => {
            const formatted = { ...expense };

            Object.keys(formatted).forEach(key => {
                if (
                    key !== 'id' &&
                    key !== 'unitIds' &&
                    typeof formatted[key as keyof OfficeExpense] === 'number'
                ) {
                    (formatted as Record<string, unknown>)[key] =
                        Number(formatted[key as keyof OfficeExpense]).toFixed(2);
                }
            });

            return formatted;
        });
    };

    const populateTierOneExpenseFormValues = (payload: Array<OfficeExpense>) => {
        // const tierOneForm = formatExpensePayload(payload);
        // resetTierOneExpenses({ officeExpenses: tierOneForm });
        resetTierTwoExpenses({ officeExpenses: formatExpensePayload(payload) });
        // resetClientProjectFormValues(false);
    }; */

    const addOfficeExpenses = async (payload: OfficeExpense) => {
        const clientNumber = selectedClient?.clientNumber;
        const payPeriod = selectedPayPeriod;
        if (!!clientNumber && !isNaN(clientNumber) && !! payPeriod && !isNaN(Number(payPeriod))) {
            payload.clientNumber = clientNumber;
            let result = await post(`/v1.0/AccountsPayable/billing/office/expense`, payload);

            if (response.ok && result === 1) {
                getOfficeExpenses();
            } else {
                console.log('Unable to get add expense data!!!');
            }
        }
    };

    const deleteOfficeExpenseUnit = async (expenseUnitId: number) => {
        if (expenseUnitId) {
            let result = await del(`/v1.0/AccountsPayable/billing/office/expense/expenseUnit/${expenseUnitId}`);

            if (response.ok && result === 1) {
                removeExpenseUnitFromLocalState(expenseUnitId);
            } else {
                console.log('Unable to delet office expense unit data!!!');
            }
        }
    };

    const updateOfficeExpenses = async (payload: OfficeExpense) => {
        let clientNumber = selectedClient?.clientNumber;
        const payPeriod =
        Number(selectedPayPeriod) > 0
            ? Number(selectedPayPeriod)
            : Number(payload.payPeriod) > 0
                ? Number(payload.payPeriod)
                : null;

        if (!payPeriod) {
            alert('Please select a pay period');
            return;
        }

        if (!clientNumber) {
            clientNumber = currentClient.clientNumber;
        }
        if (clientNumber && !isNaN(clientNumber)) {
            payload.clientNumber = clientNumber;
            let result = await put(`/v1.0/AccountsPayable/billing/office/expense`, payload);

            if (response.ok && Array.isArray(result?.officeExpenses)) {
                hydrateLocalState(result);
            } else {
                console.log('Unable to update expense data!!!');
            }
        }
    };

    const isTierOne = (expenseUnit: OfficeExpense): boolean => {
        return Array.from(tierOneExpenseProperties).some(
            property => expenseUnit[property as keyof OfficeExpense] != null
        );
    };

    const isTierTwo = (expenseUnit: OfficeExpense): boolean => {
        return Array.from(tierTwoExpenseProperties).some(
            property => expenseUnit[property as keyof OfficeExpense] != null
        );
    };

    const getExpenseProperty = (expenseUnit: OfficeExpense): keyof OfficeExpense | undefined => {
        const expenseProperties = [
            ...Array.from(tierOneExpenseProperties),
            ...Array.from(tierTwoExpenseProperties)
        ];

        return expenseProperties.find(
            property => {
                const value = expenseUnit[property as keyof OfficeExpense];
                return value !== null && value !== undefined && value !== '';
            }
        ) as keyof OfficeExpense | undefined;
    };

    const removeExpenseUnitFromLocalState = (unitId: number) => {
        const removeFromTier = (
            existingExpenseArray: OfficeExpense[],
            setTierValue: typeof setTierOneValue | typeof setTierTwoValue
        ): boolean => {
            const rowIndex = existingExpenseArray.findIndex(expenseRow =>
                Object.values(expenseRow.unitIds ?? {}).includes(unitId)
            );

            if (rowIndex < 0) {
                return false;
            }

            const row = existingExpenseArray[rowIndex];

            const expenseProperty = Object.keys(row.unitIds ?? {}).find(
                key => row.unitIds[key] === unitId
            ) as keyof OfficeExpense | undefined;

            if (!expenseProperty) {
                return false;
            }

            // Clear the expense value
            (row as unknown as Record<string, string | null>)[expenseProperty] = null;

            // Remove the UN_ID mapping
            delete row.unitIds[expenseProperty];

            setTierValue(
                `officeExpenses[${rowIndex}].${String(expenseProperty)}`,
                ''
            );

            return true;
        };

        const isTier1 = tierOneOfficeExpenses.some(row =>
            Object.values(row.unitIds ?? {}).includes(unitId)
        );

        const isTier2 = tierTwoOfficeExpenses.some(row =>
            Object.values(row.unitIds ?? {}).includes(unitId)
        );

        if (!isTier1 && !isTier2) {
            return;
        }

        const expenseArray = isTier1
            ? tierOneOfficeExpenses
            : tierTwoOfficeExpenses;

        const setValue = isTier1
            ? setTierOneValue
            : setTierTwoValue;

        removeFromTier(expenseArray, setValue);

        const newUnitManagementExpenses = unitManagementExpenses.filter(e => e.id !== unitId);

        if (newUnitManagementExpenses.length > 0) {
            setUnitManagementExpenses(newUnitManagementExpenses);
        } else if (unitManagementExpenses.length > 0) {
            const expenseType = unitManagementExpenses[0].description;

            setUnitManagementExpenses([
                {
                    id: null,
                    description: expenseType,
                    amount: null
                }
            ]);
        }
    };

    const hydrateLocalState = (deltaExpense: OfficeExpense) => {
        deltaExpense.officeExpenses.forEach(deltaUnit => {
            const expenseProperty = getExpenseProperty(deltaUnit);

            if (!expenseProperty) {
                return;
            }

            const isTier1 = isTierOne(deltaUnit);
            const isTier2 = isTierTwo(deltaUnit);

            if (!isTier1 && !isTier2) {
                return;
            }

            const expenseArray = isTier1
                ? tierOneOfficeExpenses
                : tierTwoOfficeExpenses;

            const setValue = isTier1
                ? setTierOneValue
                : setTierTwoValue;

            const setExpenseArray = isTier1
                ? setTierOneOfficeExpenses
                : setTierTwoOfficeExpenses;

            let parentExpense = expenseArray.find(
                x => x.id === deltaExpense.id
            );

            if (!parentExpense) {
                const otherExpenseArray = isTier1
                    ? tierTwoOfficeExpenses
                    : tierOneOfficeExpenses;

                parentExpense = otherExpenseArray.find(
                    x => x.id === deltaExpense.id
                );

                if (!parentExpense) {
                    return;
                }
            }

            // New or Edited unit? - determine whether an existing unit was edited
            let unitIndex = expenseArray.findIndex(
                x =>
                    x.id === deltaExpense.id &&
                    Object.values(x.unitIds ?? {}).includes(deltaUnit.unitId!)
            );

            if (unitIndex !== undefined && unitIndex >= 0) {
                const value = deltaUnit[expenseProperty] as string | undefined;

                setExpenseArray(prev =>
                    prev.map((row, index) => {
                        if (index !== unitIndex) {
                            return row;
                        }

                        return {
                            ...row,
                            [expenseProperty]: value,
                            unitIds: {
                                ...(row.unitIds ?? {}),
                                [expenseProperty]: deltaUnit.unitId
                            }
                        };
                    })
                );

                setValue(
                    `officeExpenses[${unitIndex}].${expenseProperty}`,
                    value ?? ''
                );

                setUnitManagementExpenses(prev =>
                    prev.map(expense =>
                        expense.id === deltaUnit.unitId
                            ? {
                                ...expense,
                                description: deltaUnit.otherDescription,
                                amount: deltaUnit.amount?.toString() ?? ''
                            }
                            : expense
                    )
                );

                return;
            }

            // New unit - find an existing UI row for this parent expense
            // where this expense property is empty
            unitIndex = expenseArray.findIndex(
                x =>
                    x.id === parentExpense.id &&
                    (
                        x[expenseProperty as keyof OfficeExpense] === null ||
                        x[expenseProperty as keyof OfficeExpense] === undefined ||
                        x[expenseProperty as keyof OfficeExpense] === ''
                    )
            );

            if (unitIndex >= 0) {
                const row = expenseArray[unitIndex];

                const value = deltaUnit[expenseProperty] as string | undefined;

                (row as unknown as Record<string, string | number | null | undefined>)[expenseProperty] = value;

                row.unitIds[expenseProperty] = deltaUnit.unitId!;

                setValue(
                    `officeExpenses[${unitIndex}].${expenseProperty}`,
                    value ?? ''
                );

                setExpenseArray(prev =>
                    prev.map((exp, index) => {
                        if (index !== unitIndex) {
                            return exp;
                        }

                        return {
                            ...exp,
                            [expenseProperty]: value,
                            unitIds: {
                                ...(exp.unitIds ?? {}),
                                [expenseProperty]: deltaUnit.unitId
                            }
                        };
                    })
                );

                setUnitManagementExpenses(prev =>
                    prev.map(expense => {
                        if (expense.id === null && expense.amount === null) {
                            return {
                                ...expense,
                                id: deltaUnit.unitId,
                                amount: deltaUnit.amount?.toString() ?? '',
                                description: deltaUnit.otherDescription
                            };
                        }

                        return expense;
                    })
                );

                return;
            }

            // No existing empty row - add a new row
            const newUnit = isTier1
                ? createTierOneExpense(
                    deltaExpense.id,
                    expenseProperty,
                    deltaUnit[expenseProperty] as string,
                    deltaUnit.unitId,
                    deltaUnit.entrySource
                )
                : createTierTwoExpense(
                    deltaExpense.id,
                    expenseProperty,
                    deltaUnit[expenseProperty] as string,
                    deltaUnit.unitId,
                    deltaUnit.entrySource
                );

            if (isTier1) {
                setUnitManagementExpenses(prev => [
                    ...prev,
                    { id: deltaUnit.unitId, description: deltaUnit.otherDescription, amount: deltaUnit?.amount ? deltaUnit.amount.toString() : ''}
                ]);
                setTierOneOfficeExpenses(prev => [
                    ...prev,
                    newUnit as OfficeExpense
                ]);
            } else {
                setUnitManagementExpenses(prev => [
                    ...prev,
                    { id: deltaUnit.unitId, description: deltaUnit.otherDescription, amount: deltaUnit?.amount ? deltaUnit.amount.toString() : ''}
                ]);
                setTierTwoOfficeExpenses(prev => [
                    ...prev,
                    newUnit as OfficeExpense
                ]);
            }

            setValue(
                `officeExpenses[${expenseArray?.length - 1}].${expenseProperty}`,
                deltaUnit[expenseProperty] ?? ''
            );
        });
    };

    const createTierOneExpense = (
        id: number,
        expenseProperty: keyof OfficeExpense,
        value: string | undefined,
        unitId: number,
        entrySource?: string
    ): Partial<OfficeExpense> => ({
        id,
        entrySource: entrySource,
        phone: expenseProperty === 'phone' ? value : null,
        postage: expenseProperty === 'postage' ? value : null,
        shipping: expenseProperty === 'shipping' ? value : null,
        copies: expenseProperty === 'copies' ? value : null,
        abstractFees: expenseProperty === 'abstractFees' ? value : null,
        oneThousandTwoAs: expenseProperty === 'oneThousandTwoAs' ? value : null,
        fax: expenseProperty === 'fax' ? value : null,
        officeCopies: expenseProperty === 'officeCopies' ? value : null,
            unitIds: {
            [expenseProperty]: unitId
        }
    });

    const createTierTwoExpense = (
        id: number,
        expenseProperty: string,
        value: string | undefined,
        unitId: number,
        entrySource?: string
    ): Partial<OfficeExpense> => ({
        id,
        entrySource,
        recordingFees: expenseProperty === 'recordingFees' ? value : null,
        bankCharges: expenseProperty === 'bankCharges' ? value : null,
        draft: expenseProperty === 'draft' ? value : null,
        maps: expenseProperty === 'maps' ? value : null,
        notary: expenseProperty === 'notary' ? value : null,
        formsAndSupplies: expenseProperty === 'formsAndSupplies' ? value : null,
        unitIds: {
            [expenseProperty]: unitId
        }
    });

    /*
    const updateTierTotals = () => {
        const phoneTotal = Number(document.getElementById('PhoneExpenseTotal').innerText.replace(',', ''));
        const postageTotal = Number(document.getElementById('PostageExpenseTotal').innerText.replace(',', ''));
        const shippingTotal = Number(document.getElementById('ShippingExpenseTotal').innerText.replace(',', ''));
        const copiesTotal = Number(document.getElementById('CopiesExpenseTotal').innerText.replace(',', ''));
        const abstractsTotal = Number(document.getElementById('AbstractsExpenseTotal').innerText.replace(',', ''));
        const oneZeroTwoAsTotal = Number(document.getElementById('1002AsExpenseTotal').innerText.replace(',', ''));
        const faxTotal = Number(document.getElementById('FaxExpenseTotal').innerText.replace(',', ''));
        const officeCopiesTotal = Number(document.getElementById('OfficeCopiesExpenseTotal').innerText.replace(',', ''));
        const mapsTotal = document.getElementById('MapsExpenseTotal').innerText.replace(',', '');
        const recordingTotal = document.getElementById('RecordingExpenseTotal').innerText.replace(',', '');
        const bankChargesTotal = document.getElementById('BankChargesTotal').innerText.replace(',', '');
        const draftsTotal = document.getElementById('DraftExpenseTotal').innerText.replace(',', '');
        const notoryTotal = document.getElementById('NotaryExpenseTotal').innerText.replace(',', '');
        const otherTotal = document.getElementById('OtherExpenseTotal').innerText.replace(',', '');
        const suppliesTotal = document.getElementById('SuppliesExpenseTotal').innerText.replace(',', '');
        document.getElementById('expensesTotal').innerText = formatCurrencyString(
            phoneTotal +
            postageTotal +
            shippingTotal +
            copiesTotal +
            abstractsTotal +
            oneZeroTwoAsTotal +
            faxTotal +
            officeCopiesTotal +
            Number(mapsTotal) +
            Number(recordingTotal) +
            Number(bankChargesTotal) +
            Number(draftsTotal) +
            Number(notoryTotal) +
            Number(otherTotal) +
            Number(suppliesTotal)
        );
    }; */

    const getOfficeExpenses = async () => {
        setLoadingExpenseData(true);
        const clientNumber = currentClient?.clientNumber;
        const payPeriod = selectedPayPeriod;
        const queryString = initializeOfficeExpenseSearchSettings(clientNumber, Number(payPeriod));
        let result = await get(`/v1.0/AccountsPayable/billing/office/expenses${queryString}`);

        if (response.ok) {
            setOfficeExpenses(result.items);
            setClientValue('clientName', result?.items?.[0]?.clientName);
            setClientValue('clientNumber', result?.items?.[0]?.clientNumber);
            setClientValue('projectName', result?.items?.[0]?.projectName);
            setClientValue('projectNumber', result?.items?.[0]?.projectNumber);
            setClientValue('subcodeName', result?.items?.[0]?.sectionName ? result?.items?.[0]?.sectionName : '');
            setClientValue('subcodeNumber', result?.items?.[0]?.sectionNumber ? result?.items?.[0]?.sectionNumber : '');
            setClientValue('altSubcodeName', result?.items?.[0]?.unitName ? result?.items?.[0]?.unitName : '');
            setClientValue('altSubcodeNumber', result?.items?.[0]?.unitNumber ? result?.items?.[0]?.unitNumber : '');
            if (!currentClient) {
                setCurrentClient({
                    clientName: result?.items?.[0]?.clientName,
                    clientNumber: result?.items?.[0]?.clientNumber,
                } as Partial<TsdiClient>);
            }
        } else {
            console.log('Unable to get office expense data!!!');
        }
    };

    const getOfficeExpenseReceiptsThumbnails = async () => {
        const officeExpenseId = Array.isArray(officeExpenseIds) && officeExpenseIds?.length > expenseIndex ? officeExpenseIds[expenseIndex] : null;
        if (officeExpenseId) {
            let result = await get(`/v1.0/AccountsPayable/receipts/expense/${officeExpenseId}/receipts/thumbnails`);

            if (response.ok && result?.length > 0) {
                setReceiptThumbnails(result);
            } else {
                console.log('Unable to get office expense receipt thumbnail data!!!');
            }
        }
    };

    const deleteOfficeExpenses = async () => {
        const officeExpenseId = !!officeExpenses && !!expenseIndex && officeExpenses?.length > 0 ?  officeExpenses[expenseIndex]?.id : null;
        if (!!officeExpenseId) {
            let result = await del(`/v1.0/AccountsPayable/billing/office/expenses/expenseid/${officeExpenseId}`);

            if (response.ok && result === 1) {
                getOfficeExpenses();
            } else {
                console.log('Unable to get office expense data!!!');
            }
        }
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };

    const findClient = () => {
        showDialog(DialogList.FIND_CLIENT);
    };

    const resetForm = () => {
        setNewEntryMode(true);
        const blankExpenseRow = new OfficeExpense();
        blankExpenseRow.id = -1;
        blankExpenseRow.discount = '0';
        setOfficeExpenses([blankExpenseRow]);
        resetTierOneExpenses();
        resetTierTwoExpenses();
        resetAllTotals();
    };

    const clearExpenseValues = () => {
        const emptyExpenses: {
            phone: number | null;
            copies: number | null;
            shipping: number | null;
            abstractFees: number | null;
            oneThousandTwoAs: number | null;
            fax: string | number;
            officeCopies: number | null;
        } = {
            phone: null,
            copies: null,
            shipping: null,
            abstractFees: null,
            oneThousandTwoAs: null,
            fax: null,
            officeCopies: null,
        };
        resetTierOneExpenses(emptyExpenses);
/*         for (let catIndex = 0; catIndex < expenseCategories?.length; catIndex++) {
            // console.log(category);
            const formProp = `officeExpenses[0].${expenseCategories[catIndex]}`;
            setTierOneExpensesValue(formProp, null);
        } */
    };

    const handleKeyDown = (event: KeyboardEvent) => {
        if (event.key === 'F7') {
            event.preventDefault();
            setQueryMode(prev => !prev);
        } else if (event.key === 'F8') {
            if (!!selectedPayPeriod) {
                getBillingCodeIsValid();
            } else {
                showDialog(DialogList.WARNING);
            }
        }
    };

    const getCurrentExpenseIdTotal = (): number => {
        if (!Array.isArray(officeExpenses)) {
            return 0;
        }

        const subSize = new Set(
            officeExpenses
                .filter(oe => oe.clientNumber === currentClient?.clientNumber)
                .map(oe => oe.id)
        ).size;

        setScopedTotal(subSize);
        return subSize;
    };

    const createQueryKeyListener = () => {      
          // Attach the event listener
          window.addEventListener('keydown', handleKeyDown);
    };

    const removeQueryKeyListener = () => {
        window.removeEventListener('keydown', handleKeyDown);
    };

    const prepareAddExpenseForm = () => {
        setNewEntryMode(true);
        const blankExpenseRow = new OfficeExpense();
        blankExpenseRow.id = -1;
        blankExpenseRow.discount = '0';
        setLoadingExpenseData(true);
        setOfficeExpenses([blankExpenseRow]);
        clearExpenseValues();
        resetClientProjectFormValues(false);
    };

    const resetClientProjectFormValues = (clear: boolean) => {
        if (currentClient?.clientNumber && currentClient?.clientName) {
            const accountName = !!officeExpenses && expenseIndex !== undefined ? tsdiAccounts?.find((ta) => ta?.code === officeExpenses[expenseIndex]?.accountNumber)?.description : '';
            const newSelectedProject = new ProspectDetails();
            newSelectedProject.name = !!selectedProject?.name ? selectedProject?.name : (!!officeExpenses[expenseIndex]?.projectName ? officeExpenses[expenseIndex].projectName : '');
            newSelectedProject.number = !!selectedProject?.number ? selectedProject.number : (!!officeExpenses[expenseIndex]?.projectNumber ? officeExpenses[expenseIndex].projectNumber : null);
            setSelectedProject(newSelectedProject);
            if (!clear) {
                const currentClientValues = getClientValues();
                resetClientValues({
                    ...currentClientValues,
                    // clientNumber: currentClient?.clientNumber,
                    // clientName: currentClient?.clientName,
                    // projectName: newSelectedProject.name,
                    // projectNumber: newSelectedProject.number,
                    subcodeNumber: !!selectedSubcode?.number ? selectedSubcode.number : '',
                    subcodeName: !!selectedSubcode?.name ? selectedSubcode.name : '',
                    altSubcodeNumber: !!selectedAltSubcode?.number ? selectedAltSubcode.number : '',
                    altSubcodeName: !!selectedAltSubcode?.name ? selectedAltSubcode.name : '',
                    payPeriod: selectedPayPeriod,
                    accountNumber: !!officeExpenses[expenseIndex]?.accountNumber ? officeExpenses[expenseIndex].accountNumber : '',
                    accountName: !!accountName ? accountName : '',
                    billingReceipts: !!officeExpenses[expenseIndex]?.receipts ? officeExpenses[expenseIndex].receipts : '',
                    offices: !!officeExpenses[expenseIndex]?.billingOffice ? officeExpenses[expenseIndex].billingOffice : ''
                });
            } else {
                resetClientValues({
                    clientNumber: null,
                    clientName: null,
                    projectName: null,
                    projectNumber: null,
                    subcodeNumber: null,
                    subcodeName: null,
                    payPeriod: null,
                    accountNumber: null,
                    accountName: null,
                    billingReceipts: null,
                    offices: null
                });
            }
        }
    };

    const getBeginAndEndDatesFromPayPeriod = (
        payPeriod: number
    ): { beginDate: Date; endDate: Date } => {
        const year = Math.floor(payPeriod / 100);
        const period = payPeriod % 100;

        const month = Math.floor((period - 1) / 2); // 0 = Jan, 1 = Feb, etc.
        const firstHalf = period % 2 === 1;

        const beginDate = firstHalf
            ? new Date(year, month, 1)
            : new Date(year, month, 16);

        const endDate = firstHalf
            ? new Date(year, month, 15)
            : new Date(year, month + 1, 0); // Last day of month

        return { beginDate, endDate };
    };

    const prepareAddExpensePayload = (expenseFormData: object) => {
        const payPeriodObject = payPeriods.find((pp) => pp.name.replace('-', '') === selectedPayPeriod);
        const parentExpense = new OfficeExpense();
        const clientFormValues = getClientValues();
        parentExpense.accountNumber = Number(clientFormValues?.accountNumber);
        parentExpense.payPeriod = clientFormValues?.payPeriod ? Number(clientFormValues?.payPeriod) : officeExpenses?.[expenseIndex]?.payPeriod;
        if (!parentExpense.payPeriod) {
            alert('Cannot determine pay period.');
            return null;
        }
        parentExpense.projectNumber = Number(clientFormValues?.projectNumber);
        parentExpense.beginDate = payPeriodObject?.beginDate;
        parentExpense.endDate = payPeriodObject?.endDate;
        if (!parentExpense.beginDate || parentExpense.endDate) {
            const dateObject = getBeginAndEndDatesFromPayPeriod(parentExpense.payPeriod);
            parentExpense.beginDate = dateObject.beginDate;
            parentExpense.endDate = dateObject.endDate;
        }
        parentExpense.sectionNumber = !!clientFormValues?.subcodeNumber && !isNaN(Number(clientFormValues?.subcodeNumber)) ?
         Number(clientFormValues?.subcodeNumber) : null;
        parentExpense.unitNumber = !!clientFormValues?.altSubcodeNumber && !isNaN(Number(clientFormValues?.altSubcodeNumber)) ?
        Number(clientFormValues?.altSubcodeNumber) : null;
        return parentExpense;
    };

    const transformToExpenseArray = (
        input: Record<string, string>,
        displayTier: number
    ): {
        expenseType: string;
        amount: number;
        id?: number;
        unitId?: string | number | null;
        otherDescription?: string;
    }[] => {
        const { id, otherDescription } = input;

        const existingExpenses =
            displayTier === 1
                ? tierOneOfficeExpenses.filter(oe => oe.id === Number(id))
                : tierTwoOfficeExpenses.filter(oe => oe.id === Number(id));

        // Track how many existing expense/unitId combinations have already matched
        const matchedExisting = new Set<string>();

        return Object.entries(input).reduce((acc, [key, value]) => {
            const amount = Number(value);

            if (
                amount > 0 &&
                key !== 'otherDescription' &&
                key !== 'id' &&
                key !== 'unitId'
            ) {
                // Find an existing expense of the same type and amount with an unused unitId
                const existingExpense = existingExpenses.find((oe, index) => {
                    const existingUnitId = oe.unitIds?.[key];

                    return (
                        existingUnitId != null &&
                        Number(oe[key as keyof OfficeExpense] ?? 0) === amount &&
                        !matchedExisting.has(`${key}-${amount}-${existingUnitId}-${index}`)
                    );
                });

                if (existingExpense) {
                    const index = existingExpenses.indexOf(existingExpense);
                    const existingUnitId = existingExpense.unitIds?.[key];

                    matchedExisting.add(`${key}-${amount}-${existingUnitId}-${index}`);

                    // Existing expense with same amount already exists; don't return it
                    return acc;
                }

                const existingSameType = existingExpenses.filter(oe =>
                    oe.unitIds?.[key] != null
                );

                const expense: {
                    expenseType: string;
                    amount: number;
                    id?: number;
                    unitId?: string | number | null;
                    otherDescription?: string;
                } = {
                    expenseType: key,
                    amount,
                    id: Number(id),
                    unitId:
                        existingSameType.length === 1
                            ? existingSameType[0].unitIds?.[key] ?? null
                            : null
                };

                if (key === 'other' && otherDescription) {
                    expense.otherDescription = otherDescription;
                }

                acc.push(expense);
            }

            return acc;
        }, [] as {
            expenseType: string;
            amount: number;
            id?: number;
            unitId?: string | number | null;
            otherDescription?: string;
        }[]);
    };

    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        let newExpensePayload: OfficeExpense = undefined;
        let parentExpenseId = 0;
        if (isDirtyTierOne) {
            // expenses have been entered
            const tierOneFormState = getTierOneExpenses();
            const cleanedArray = (tierOneFormState.officeExpenses as Array<OfficeExpense>).filter(item => item !== null && item !== undefined);
            parentExpenseId = !!cleanedArray && cleanedArray.length > 0 ? cleanedArray[0]?.id : null;
            const parentExpense = prepareAddExpensePayload(tierOneFormState);
            parentExpense.officeExpenses = new Array<OfficeExpense>();
            // add Amount (totaly from all children expenses)
/*             let expenseIndices = new Array<number>();
            if (!!tierOneFormState?.officeExpenses) {
                const validIndices = (tierOneFormState?.officeExpenses as OfficeExpense[]).reduce<number[]>((acc, item, index) => {
                    if (item !== null && item !== undefined) {
                        acc.push(index);
                    }
                    return acc;
                    }, []);
                if (!!validIndices && validIndices.length > 0) {
                    expenseIndices = [...validIndices];
                }
            } */
            const allExpenses = !!tierOneFormState?.officeExpenses ? tierOneFormState?.officeExpenses.filter((item: object): item is object => item !== undefined) : null;
            if (Array.isArray(allExpenses)) {
                // newExpenses.forEach((item: OfficeExpense) => {
                //     item.entrySource = 'FORM';
                //    item.createdDate = new Date();
                //    item.createdBy = appContext.currentUser.username;
                //    item.code = getCodeOrType(item.expenseType, true);
                //    item.expenseType = getCodeOrType(item.expenseType, false);
                // });
                // parentExpense.officeExpenses = [...parentExpense.officeExpenses, ...newExpenses];
                 for (let officeExpenseIndex = 0; officeExpenseIndex < allExpenses.length; officeExpenseIndex++) {
                    const newExpenseUnits = transformToExpenseArray(allExpenses[officeExpenseIndex], 1) as unknown as Array<OfficeExpense>;
                    newExpenseUnits.forEach(item => {
                        item.entrySource = 'FORM';
                        item.createdDate = new Date();
                        item.createdBy = appContext.currentUser.username;
                        item.code = getCodeOrType(item.expenseType, true);
                        item.expenseType = getCodeOrType(item.expenseType, false);
                        item.otherDescription = expenseCodesAndTypes.find(ect => ect?.code?.toString() === item?.code && ect?.type === item?.expenseType )?.description;
                    });
                    parentExpense.officeExpenses = [...parentExpense.officeExpenses, ...newExpenseUnits];
                }
            }
            const totalAmount = parentExpense.officeExpenses.reduce((sum, item) => sum + item.amount, 0);
            parentExpense.amount = totalAmount;
            newExpensePayload = parentExpense;
        }  else {
            const tierOneFormState = getTierOneExpenses();
            const parentExpense = prepareAddExpensePayload(tierOneFormState);
            const cleanedArray = (tierOneFormState.officeExpenses as Array<OfficeExpense>).filter(item => item !== null && item !== undefined);
            parentExpenseId = !!cleanedArray && cleanedArray.length > 0 ? cleanedArray[0]?.id : null;
            parentExpense.officeExpenses = new Array<OfficeExpense>();
            if (!!newExpensePayload) {
                newExpensePayload.amount += parentExpense.officeExpenses.reduce((sum, item) => sum + item.amount, 0);
            }
        }

        if (isDirtyTierTwo) {
            // expenses have been entered
            const tierTwoFormState = getTierTwoExpenses();
            const parentExpense = prepareAddExpensePayload(tierTwoFormState);
            const cleanedArray = (tierTwoFormState.officeExpenses as Array<OfficeExpense>).filter(item => item !== null && item !== undefined);
            if (!parentExpenseId) {
                parentExpenseId = !!cleanedArray && cleanedArray.length > 0 ? cleanedArray[0]?.id : null;
            }
            parentExpense.officeExpenses = new Array<OfficeExpense>();
            let expenseIndices = new Array<number>();
            // add Amount (totaly from all children expenses)
            if (!!tierTwoFormState?.officeExpenses) {
                const validIndices = (tierTwoFormState?.officeExpenses as OfficeExpense[]).reduce<number[]>((acc, item, index) => {
                    if (item !== null && item !== undefined) {
                        acc.push(index);
                    }
                    return acc;
                    }, []);
                if (!!validIndices && validIndices.length > 0) {
                    expenseIndices = [...validIndices];
                }
            }
            const newExpenses = !!tierTwoFormState?.officeExpenses ? tierTwoFormState?.officeExpenses.filter((item: object): item is object => item !== undefined) : null;
            if (!!newExpenses) {
                for (let officeExpenseIndex = 0; officeExpenseIndex < newExpenses.length; officeExpenseIndex++) {
                    const newExpenseUnits = transformToExpenseArray(newExpenses[officeExpenseIndex], 2) as unknown as Array<OfficeExpense>;
                    newExpenseUnits.forEach(item => {
                        item.entrySource = 'FORM';
                        item.createdDate = new Date();
                        item.createdBy = appContext.currentUser.username;
                        item.code = getCodeOrType(item.expenseType, true);
                        if (!!item?.code && item.code === 'O') {
                            item.otherDescription = newExpenses[officeExpenseIndex].otherDescription;
                        }
                        item.expenseType = getCodeOrType(item.expenseType, false);
                        item.unitId = officeExpenses[expenseIndices[officeExpenseIndex]]
                            ?.officeExpenses
                            ?.find(exp => exp.code === item.code)
                            ?.unitId ?? null;
                        });
                    parentExpense.officeExpenses = [...parentExpense.officeExpenses, ...newExpenseUnits];
                }
            }
            const totalAmount = parentExpense.officeExpenses.reduce((sum, item) => sum + item.amount, 0);
            parentExpense.amount = totalAmount;
            if (newExpensePayload === undefined) {
                newExpensePayload = parentExpense;
            } else {
                newExpensePayload.amount += parentExpense.amount;
                newExpensePayload.officeExpenses = [...newExpensePayload.officeExpenses, ...parentExpense.officeExpenses];
            }
        } else {
            const tierTwoFormState = getTierTwoExpenses();
            if (tierTwoFormState?.officeExpenses) {
                const parentExpense = prepareAddExpensePayload(tierTwoFormState);
                const cleanedArray = (tierTwoFormState.officeExpenses as Array<OfficeExpense>).filter(item => item !== null && item !== undefined);
                if (!parentExpenseId) {
                    parentExpenseId = !!cleanedArray && cleanedArray.length > 0 ? cleanedArray[0]?.id : null;
                }
                parentExpense.officeExpenses = new Array<OfficeExpense>();
                if (!!newExpensePayload) {
                    newExpensePayload.amount += parentExpense.officeExpenses.reduce((sum, item) => sum + item.amount, 0);
                }
            }
        }
        
        if ((isDirtyTierOne || isDirtyTierTwo) && newExpensePayload !== undefined) {
            newExpensePayload.id = !!parentExpenseId && !isNaN(Number(parentExpenseId)) ? Number(parentExpenseId) : null;
            if (!editMode) {
                addOfficeExpenses(newExpensePayload);
            } else {
                setEditMode(false);
                updateOfficeExpenses(newExpensePayload);
            }
        }
    };

    const reportOptions = () => {
        showDialog(DialogList.REPORT_OPTIONS);
    };

    const moveToFirstExpense = () => {
        if (!!officeExpenseIds && officeExpenseIds?.length > 1) {
            resetAllTotals();
            setExpenseIndex(0);
            setCurrentExpenseId(officeExpenseIds[0]);
        }
    };

    const moveToNextExpense = () => {
        if (expenseIndex < officeExpenseIds?.length - 1) {
            // let nextIndex = expenseIndex + 1;
            // const currentId = officeExpenseIds[expenseIndex];
            // while (currentId === officeExpenseIds[nextIndex] && nextIndex < officeExpenses?.length - 1) {
            //     nextIndex++;
            // }
            resetAllTotals();
            setClientValue('billingReceipts', null);
            setReceiptThumbnails(null);
            setSelectedProject(undefined);
            setCurrentExpenseId(officeExpenseIds[expenseIndex + 1]);
            setExpenseIndex(expenseIndex + 1);
            setScopedCounter(prev => prev + 1);
        }
    };

    const moveToLastExpense = () => {
        if (!!officeExpenseIds && officeExpenseIds?.length > 1) {
            resetAllTotals();
            setExpenseIndex(officeExpenseIds.length - 1);
        }
    };

    const moveToPreviousExpense = () => {
        if (expenseIndex > 0) {
            resetAllTotals();
            let nextIndex = expenseIndex - 1;
            // const currentId = officeExpenseIds[expenseIndex];
            // while (currentId === officeExpenseIds[nextIndex] && nextIndex > 0) {
            //     nextIndex--;
            // }
            setCurrentExpenseId(officeExpenseIds[nextIndex]);
            setExpenseIndex(nextIndex);
            setScopedCounter(prev => prev - 1);
        }
    };

    const setSelectedPayPeriodValue = (value: string) => {
        if (!value) {
            setSelectedPayPeriod(undefined);
            return;
        }
        if (Array.isArray(payPeriods)) {
            const labelValue: PayPeriod = payPeriods.find((pp) =>
                pp.id.toString() === value
            );
            if (!!labelValue?.name) {
                setSelectedPayPeriod(labelValue.name.toString().replace('-', ''));
            }
        }
    };

    const loadData = () => {
        setOfficeExpenses([]);
        getOfficeExpenses();
    };

    const onSubmitOfficeExpenseUnitChanges = (payload: Array<OfficeExpenseUnitEntry>) => {
        if (Array.isArray(payload)) {
            const officeExpenseId = officeExpenseIds[expenseIndex];
            const existingParentExpense = officeExpenses.find(oe => oe.id === officeExpenseId);
            const parentExpense = _.cloneDeep(existingParentExpense);
            parentExpense.officeExpenses = new Array<OfficeExpense>();

            payload.forEach (p => {
                const nextOfficeExpense = new OfficeExpense();
                const amount = Number(p.amount);
                nextOfficeExpense.createdBy = appContext.currentUser.username;
                nextOfficeExpense.createdDate = new Date();
                nextOfficeExpense.unitId = !isNaN(Number(p.id)) && Number(p.id) !== 0 ? Number(p.id) : null;
                nextOfficeExpense.otherDescription = p.description;
                nextOfficeExpense.code = getCodeOrType(p.type !== 'Other' ? p.description : p.type, true);
                nextOfficeExpense.expenseType = getCodeOrType(p.type !== 'Other' ? p.description : p.type, false);
                nextOfficeExpense.imageBase64 = null;
                (nextOfficeExpense as unknown as Record<string, string | null>)[expenseCategoryLabels[p.description]] = amount.toString();
                nextOfficeExpense.amount = amount;
                const entrySource = officeExpenses.find(oe => oe.unitId === nextOfficeExpense.unitId)?.entrySource;
                nextOfficeExpense.entrySource = entrySource ? entrySource : 'FORM';
                parentExpense.officeExpenses.push(nextOfficeExpense);
            });
            updateOfficeExpenses(parentExpense);
        }
    };

    return (
        <>
        <div>
        <PBNavBar/>
            <ClientProjectSearch
                projects={true}
                subcodes={true}
                altSubcodes={true}
                parentComponent={'OfficeExpenses'}
                offices={officeOptionValues.map(o => o.label)}
                setSelectedClient={setSelectedClient}
                setPayPeriodSearchTerm={setPayPeriodSearchTerm}
                setSelectedPayPeriod={setSelectedPayPeriodValue}
                payPeriods={!!payPeriods && payPeriods.length > 0 ?
                    payPeriods?.map((pp) => { return {id: pp?.id, name: !!pp?.name ? pp?.name : ''}; }) : []}
                clients={clients}
                runQuery={loadData}
                size={8}
            />
           <div id={'OfficeExpensePage'} style={{margin: '0 auto', display: 'flex', flexDirection: 'column', maxWidth: '68vw', justifyContent: 'center'}}>
                <Page className="dlc-maxer-width">                    
                    <Page.Section width={14}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel panelTitle={displayTitle()}>
                                <form id={`OfficeExpenseFormClientInfo`}>
                                    <div style={{ border: 'solid rgb(99, 147, 193) 1px', padding: '.5rem' }}>
                                        <div className="form-row" style={{ marginBottom: '0' }}>
                                            <RHFInputBox
                                                name={'clientNumber'}
                                                style={{width: '100%'}}
                                                bodyStyle={{width: '25%'}}
                                                register={registerClientValues}
                                                readOnly={!queryMode}
                                            />
                                            <RHFInputBox
                                                name={'clientName'}
                                                style={{width: '100%'}}
                                                register={registerClientValues}
                                                readOnly={true}
                                            />
                                            <RHFInputBox
                                                name={'projectNumber'}
                                                style={{width: '100%'}}
                                                bodyStyle={{width: '25%'}}
                                                register={registerClientValues}
                                                readOnly={!queryMode}
                                            />
                                            <RHFInputBox
                                                name={'projectName'}
                                                style={{width: '100%'}}
                                                register={registerClientValues}
                                                readOnly={true}
                                            />
                                            <RHFInputBox
                                                name={'subcodeNumber'}
                                                style={{width: '100%'}}
                                                bodyStyle={{width: '25%'}}
                                                register={registerClientValues}
                                                readOnly={!queryMode}
                                            />
                                            <RHFInputBox
                                                name={'subcodeName'}
                                                style={{width: '100%'}}
                                                register={registerClientValues}
                                                readOnly={true}
                                            />
                                            <RHFInputBox
                                                name={'altSubcodeNumber'}
                                                style={{width: '100%'}}
                                                bodyStyle={{width: '25%'}}
                                                register={registerClientValues}
                                                readOnly={!queryMode}
                                            />
                                            <RHFInputBox
                                                name={'altSubcodeName'}
                                                style={{width: '100%'}}
                                                register={registerClientValues}
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </Panel>
                        </Panel>
                    </Page.Section>
                </Page>
                <Page className="dlc-maxer-width">
                    <Page.Section width={14}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel panelTitle={displayHeading2()}>
                                <form id={`OfficeExpenseButtons`} onSubmit={onSubmit}>
                                    <div style={{marginBottom: '1rem', display: 'flex', width: '100%', justifyContent: 'center'}}>
                                        {displayOfficeExpenseButtons()}
                                    </div>
                                </form>
                                <div style={{marginBottom: '.5rem', display: 'flex', width: '100%', justifyContent: 'center'}}>
                                    {loadingExpenseData && (
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <span>Retreiving Expenses...</span>
                                            <LoadingSpinner />
                                        </div>
                                    )}
                                </div>
                                <div style={{ border: 'solid rgb(99, 147, 193) 1px', paddingBottom: '.5rem' }}>
                                    {displayOfficeExpenses()}
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                </Page>
            </div>
        </div>
            <FindClientDialog
                dialogName={DialogList.FIND_CLIENT}
                hideDialog={hideDialog}
                clients={clients}
                setClientSearchTerm={setClientSearchTerm}
                onCancel={onCancel}
                style={{maxHeight: '50vw'}}
                setSelectedClient={setSelectedClient}
            />
            <WarningDialog
                selectedClient={selectedClient?.clientNumber}
                hideDialog={hideDialog}
                dialogName={DialogList.WARNING}
                hasProjects={!!selectedProject}
                handleConfirm={hideDialog}
                selectedPayPeriod={selectedPayPeriod}
                context={2}
                label={!selectedPayPeriod ? 'Please select a pay period.' : (!selectedClient ?
                    'Please select a client' : 'Pay period and client required.')}
            />
            <ReceiptViewerDialog
                context={1}
                dialogName={DialogList.RECEIPT_VIEWER}
                hideDialog={hideDialog}
                receipts={receiptThumbnails}
                handleConfirm={hideDialog}
            />
            <TransferExpenseDialog
                dialogName={DialogList.TRANSFER_OFFICE_EXPENSE}
                hideDialog={hideDialog}
                showDialog={showDialog}
                officeExpense={transferEexpense}
                onSubmit={() => hideDialog()}
            />
            <OfficeExpenseUnitManagementDialog
                dialogName={DialogList.MANAGE_OFFICE_EXPENSE_UNIT}
                hideDialog={hideDialog}
                showDialog={showDialog}
                officeExpense={unitManagementExpense}
                officeExpenseUnits={unitManagementExpenses}
                onSubmit={onSubmitOfficeExpenseUnitChanges}
                deleteOfficeExpenseUnit={deleteOfficeExpenseUnit}
            />
            <OfficeExpenseReportOptionsDialog
                handleOfficeExpenseReport={(data: { payPeriod: number, office: string}) => getOfficeExpensesReportFile(2, data.payPeriod, data.office)}
                dialogName={DialogList.REPORT_OPTIONS}
                hideDialog={hideDialog}
                showDialog={showDialog}
                reportTypes={[
                    { value: '1', label: 'Office Expense (Standard)' },
                    { value: '2', label: 'Office Expense (Extended)' }
                ]}
                offices={officeOptionValues}
                payPeriods={payPeriods?.map(p => {
                    return {
                        label: (!!p.name ? `(${p.name})` : ''),
                        value: `${p.id}` };
                })}
            />
        </>
    );
};

export default OfficeExpensePage;



// WEBPACK FOOTER //
// ./src/components/project-billing/pages/OfficeExpensePage.tsx